import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import { StrictModeDroppable } from "../../components/StrictModeDroppable";
import {
  Box,
  Button,
  FormLabel,
  FormControl,
  TextField,
  Typography,
  Grid2,
  Snackbar,
  Alert,
  IconButton,
  TextareaAutosize,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu, MenuItem, Divider,
  InputLabel,
  Select,
  Tooltip,
  Stack,
  Avatar,
  Breadcrumbs,
  Link,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import {
  getContentTypeForEntry,
  submitFormData,
  resetForm
} from "../../actions/entryActions";
import isEqual from 'lodash/isEqual';
import { usePermission } from "../authentication/permission-providor/UserPermission";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import LanguageIcon from '@mui/icons-material/Language';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import Ai_Icon from '../../assets/images/ai_icon.png';
import Translation_Icon from '../../assets/images/translation_icon.svg';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import JsonEditor from "./JsonEditor";
import CodeEditor from "./CodeEditor";
import useMediaQuery from '@mui/material/useMediaQuery';
import StyledTextArea from "../../themes/overrides/TextArea";
import { useNavigate, useLocation } from 'react-router-dom';
import VersionDrawer from "../../components/VersionDrawer";
import CircularProgress from '@mui/material/CircularProgress';
import AiEditPromptModal from "../../components/AiEditPromptModal";
import { handleAiGenerate } from "../../components/HandleAiGenerate";
import { handleTranslate } from "../../components/HandleTranslate";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TagIcon from '@mui/icons-material/Tag';
import TitleIcon from '@mui/icons-material/Title';
import NotesIcon from '@mui/icons-material/Notes';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import NumbersIcon from '@mui/icons-material/Numbers';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import DataObjectIcon from '@mui/icons-material/DataObject';
import CodeIcon from '@mui/icons-material/Code';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LaunchIcon from '@mui/icons-material/Launch';
import CommentsDrawer from "../../components/comments/CommentsDrawer";
import FieldCommentBadge from "../../components/comments/FieldCommentBadge";
import { getCommentCounts } from "../../actions/commentActions";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { getEntryForEdit, getAllEntries, updateEntryData, updatePreviewEntryData, getEntryVersions, scheduleEntryData } from "../../actions/entryActions";
import ScheduleIcon from '@mui/icons-material/Schedule';
import SchedulePublishModal from "../../components/SchedulePublishModal";
import { getSpecificWorkspace } from "../../actions/workspaceAction";

import { useParams } from "react-router-dom";
import RichText from "../../components/richText/RichText";
import CloudIcon from "../../assets/images/cloud-add.svg"
import CloudIcon2 from "../../assets/images/cloud-add2.svg"
import SaveDraftIcon from "../../assets/images/simcard.svg"
import SaveDraftIcon2 from "../../assets/images/simcard2.svg"
import { BorderAll, BorderColor } from "@mui/icons-material";
import TextFieldInput from "../../themes/overrides/TextFieldInput";
import MediaUpload from "../../components/Media/MediaUpload";
import DateTimeEntry from "../../components/DateTimeEntry";
import BooleanEntry from "../../components/BooleanEntry"
import RightDrawer from "../../components/RightDrawer";
import AddReferrenceModal from "./AddReferenceModal";
import RemoveIcon from "../../components/icons/RemoveIcon";
import AddExistingEntryPopup from "../../components/AddExistingEntryPopup";
import DeleteIcon from '../../assets/images/icons/delete_icon.svg';
import editIcon from "../../assets/images/icons/edit-2-Black.svg";
import LoadingOverlay from "../../components/LoadingOverlay";
import LoadingSpinner from "../../components/icons/LoadingSpinner";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ColorEntry from "../../components/ColorEntry";
import slugify from "../../components/slugGenerator";
import debounce from "../../components/debounceHelper";
import { getFriendlyErrorMessage } from "../../utils/entryErrorUtils";


// Info drawer
import EntryInfoDrawer from "../../components/EntryInfoDrawer";
import ScrollToTopFab from "../../components/ScrollToTopFab";
import AiGenerateEntryModal from "../../components/AiGenerateEntryModal";

//To Show active users on the page
import { db } from "../../firebase";
import { ref, set, onValue, onDisconnect, serverTimestamp, remove } from "firebase/database";


// Formats an ISO date for the sidebar "Last updated" row (e.g. "May 12, 2025, 10:30 AM")
const formatDateTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

// Small white (or tinted) card used in the right-hand sidebar
const SidebarCard = ({ title, icon = null, tinted = false, children }) => (
  <div
    className={`rounded-2xl border p-5 ${tinted
      ? 'bg-[#fbfbff] border-indigo-100/80'
      : 'bg-white border-slate-200/70 shadow-sm'
      }`}
  >
    <div className="flex items-center gap-2 mb-3.5">
      {icon}
      <p className="text-sm font-bold text-slate-800">{title}</p>
    </div>
    {children}
  </div>
);

// Light indigo icon tile shown to the left of each form field
const FIELD_TYPE_ICONS = {
  string: TitleIcon,
  richText: NotesIcon,
  media: ImageOutlinedIcon,
  dateTime: CalendarMonthOutlinedIcon,
  number: NumbersIcon,
  boolean: ToggleOnOutlinedIcon,
  color: PaletteOutlinedIcon,
  object: DataObjectIcon,
  code: CodeIcon,
  array: FormatListBulletedIcon,
  reference: LinkOutlinedIcon,
};

const FieldIconTile = ({ type, variant }) => {
  let Icon = FIELD_TYPE_ICONS[type] || TitleIcon;
  if (type === 'string' && variant === 'slugField') Icon = TagIcon;
  if (type === 'string' && variant === 'longText') Icon = NotesIcon;
  return (
    <div className="w-9 h-9 rounded-lg bg-indigo-50 text-indigo-500 flex items-center justify-center shrink-0">
      <Icon sx={{ fontSize: 18 }} />
    </div>
  );
};

const CreateEntry = ({ contentType, onConfirm, isDrawer, editEntry, isDrawerEdit, initialFormData, isVersionPreview = false, breadcrumbs = [], compareWith, diffType }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = usePermission();

  const saveButtonRef = useRef(null);
  const formRef = useRef();
  const [formData, setFormData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const data = useSelector((state) => state.entry.entryFields);
  const entryName = useSelector((state) => state.entry.entryName);
  const previewUrl = useSelector((state) => state.entry.entryContentTypePreviewUrl);

  const { success, error, isSaved, entryData } = useSelector((state) => state.entry);
  const entrySelector = useSelector((state) => state.entry.entry) || [];
  const entry = entrySelector?.entry;
  const entries = useSelector((state) => state.entry.entries) || [];
  const currentWorkspace = useSelector((state) => state.workspace.workspaceInfo);
  const allContentTypes = useSelector((state) => state.form.contentTypes);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [addExistingEntryPopup, setAddExistingEntryPopup] = useState({
    open: false,
    fieldId: null
  });
  const [referenceEditing, setReferenceEditing] = useState({
    isEditing: false,
    entryData: null,
    fieldId: null
  });
  const [isNestedCreate, setIsNestedCreate] = useState(isDrawer && !isDrawerEdit);
  const [isDrawerContext, setIsDrawerContext] = useState(isDrawer);
  const [richTextState, setRichTextState] = useState({
    isReady: false,
    isDataLoaded: false
  });
  const [isViewOnly, setIsViewOnly] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(() => {
    const pathParts = window.location.pathname.split('/');
    const isEdit = pathParts.includes('edit-entry');
    const entryId = pathParts[pathParts.length - 1];
    if (isEdit) {
      // If editing and we don't have the entry yet, or it's the wrong entry
      return !entrySelector?.entry || entrySelector.entry._id !== entryId;
    }
    return false; // Create mode usually starts with form ready
  });
  const [selectedRefs, setSelectedRefs] = useState({});
  const [currentContentId, setContentId] = useState("");
  const [isEntriesFetched, setIsEntriesFetched] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);
  const [publishDraftLoading, setPublishDraftLoading] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState({ scheduledAt: null, scheduledUnpublishAt: null });
  const [errors, setErrors] = useState({});
  const [versionPanelOpen, setVersionPanelOpen] = useState(false);
  const [modifiedFields, setModifiedFields] = useState({});
  const [modifiedLocaleFields, setModifiedLocaleFields] = useState({});
  const [editIconLoading, setEditIconLoading] = useState({});
  const [savePreviewLoading, setSavePreviewLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const initialFormDataRef = useRef({});

  const [aiAnchorEl, setAiAnchorEl] = useState({});
  const [aiDropdown, setAiDropdown] = useState({});
  const [aiEditPromptPopupOpen, setAiEditPromptPopupOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(null);
  const [aiLoading, setAiLoading] = useState({});
  const [translationLoading, setTranslationLoading] = useState({});
  // Per-field ({ [fieldId]: bool }) and whole-entry translate-into-all-locales progress.
  const [fieldTranslating, setFieldTranslating] = useState({});
  const [bulkTranslating, setBulkTranslating] = useState(false);

  // Hide and show locale fields
  const [showAllLocales, setShowAllLocales] = useState(false);


  const [spaceLocales, setSpaceLocales] = useState(["en"]);
  const primaryLocale = ["en"];
  // State for dynamic fields, map by field ids+
  const [fields, setFields] = useState({});
  const { workspaceId, id } = useParams();
  const arrayFocusRefs = useRef({});
  const lastFetchedEntryId = useRef(null); // Guard for duplicate fetches
  const [lastArrAdded, setLastArrAdded] = useState(null); // Used for array adding items to move cursor
  // const [initialExistingEntries, setInitialExistingEntries] = useState([]); // Removed eager fetch

  // Ref parent entry
  const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);
  const [parentEntriesData, setParentEntriesData] = useState([]);

  // Entry comments
  const [commentsDrawerOpen, setCommentsDrawerOpen] = useState(false);
  const [commentsFieldAnchor, setCommentsFieldAnchor] = useState(null); // { fieldId, fieldName } | null
  const commentCounts = useSelector((state) => state.comments.counts);
  // Comments only exist for saved entries opened from the route (not nested drawers/version previews)
  const commentsEnabled = isEditMode && !isDrawer && !isVersionPreview;

  // For slug field (When edited the slug wont auto generate)
  const [manualSlugEdits, setManualSlugEdits] = useState({});

  //Show Active Users
  const [users, setUsers] = useState([]);

  // Co-editing presence: current user id, used to exclude ourselves from the
  // "is editing" banner and to tag our own saves in the room.
  const currentUserId = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('userInfo'))?._id || null;
    } catch {
      return null;
    }
  }, []);
  const otherEditors = users.filter((u) => u.uid && u.uid !== currentUserId);

  // Stale-write detection: set when someone else saved this entry after we opened it
  const [staleSave, setStaleSave] = useState(null); // { name, at } | null
  const [staleConfirmOpen, setStaleConfirmOpen] = useState(false);
  const pendingSubmitRef = useRef(null); // { status, isPreview } stashed while the stale-write dialog is open
  const lastSaveBaselineRef = useRef({}); // entryId -> lastSave.at seen when we opened the entry
  const presenceEntryIdRef = useRef(null);

  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Save split-button caret menu
  const [saveMenuAnchorEl, setSaveMenuAnchorEl] = useState(null);
  const saveMenuOpen = Boolean(saveMenuAnchorEl);

  const handleSaveMenuClick = (event) => {
    setSaveMenuAnchorEl(event.currentTarget);
  };

  const handleSaveMenuClose = () => {
    setSaveMenuAnchorEl(null);
  };

  const handleCopyEntryId = async (entryId) => {
    try {
      await navigator.clipboard.writeText(entryId);
      setSuccessMessage("Entry ID copied to clipboard");
      setSeverity("success");
      setOpenSnackbar(true);
    } catch (err) {
      console.error('Failed to copy entry ID:', err);
    }
  };

  const handleDrawerClose = (event) => {
    setVersionPanelOpen(false);
    setAnchorEl(null);
  };

  const handleAiArrowClick = (event, id, locale) => {
    const key = `${id}-${locale}`;
    setAiAnchorEl((prev) => ({ ...prev, [key]: event.currentTarget }));
    setAiDropdown((prev) => ({ ...prev, [key]: true }));
  };


  const handleAiCloseDropdown = (id, locale) => {
    const key = `${id}-${locale}`;
    setAiAnchorEl((prev) => ({ ...prev, [key]: null }));
    setAiDropdown((prev) => ({ ...prev, [key]: false }));
  };


  const handleAiEditPrompt = (selectedField) => {
    setAiDropdown(false);

    setAiEditPromptPopupOpen(true);
    setSelectedField(selectedField);
  };

  const onAiGenerateClick = async (prompt, id, locale, field) => {
    handleAiGenerate({
      prompt,
      id,
      locale,
      currentWorkspace,
      setAiLoading,
      setFormData,
      setErrorMessage,
      setOpenSnackbar,
      setSeverity,
      fieldType: field.type
    });
  };

  // useEffect(() => {
  //   const fetchInitialEntries = async () => {
  //     const result = await dispatch(getAllEntries(workspaceId, { page: 1 }));
  //     setInitialExistingEntries(result.entries || []);
  //   };

  //   if (workspaceId) {
  //     fetchInitialEntries();
  //   }
  // }, [workspaceId, dispatch]);

  const onTranslateClick = async (id, locale, field, overwrite = false) => {


    const fieldType = field.type === 'array' && field.array_type === 'string'
      ? 'array_string'
      : field.type;


    await handleTranslate({
      id: id,
      locale: locale,
      formData,
      handleChange,
      setTranslationLoading,
      setErrorMessage,
      setOpenSnackbar,
      setSeverity,
      fieldType,
      overwrite
    });
  };

  // Only text-like fields can be machine-translated from English.
  const isTranslatableField = (field) =>
    field?.localizations &&
    (field.type === 'string' ||
      field.type === 'richText' ||
      (field.type === 'array' && field.array_type === 'string'));

  // Field has a non-empty English source value to translate from.
  const hasEnglishValue = (field) => {
    const en = formData[field.id]?.['en'];
    if (Array.isArray(en)) return en.length > 0;
    return en !== undefined && en !== null && en !== '';
  };

  // Translate a single field's English value into every other workspace locale.
  const onTranslateFieldAllLocales = async (field) => {
    const targetLocales = spaceLocales.filter((l) => l !== 'en');
    if (!isTranslatableField(field) || targetLocales.length === 0) return;
    if (!hasEnglishValue(field)) {
      setErrorMessage(`No English value for "${field.name}" to translate`);
      setSeverity('warning');
      setOpenSnackbar(true);
      return;
    }

    setFieldTranslating((prev) => ({ ...prev, [field.id]: true }));
    try {
      // Each locale writes a different key, so they are safe to run in parallel.
      await Promise.all(
        targetLocales.map((locale) => onTranslateClick(field.id, locale, field, true))
      );
    } finally {
      setFieldTranslating((prev) => ({ ...prev, [field.id]: false }));
    }
  };

  // Translate every localizable text field of the entry into every other locale.
  const onTranslateWholeEntry = async () => {
    const targetLocales = spaceLocales.filter((l) => l !== 'en');
    const allFields = (contentType?.contentType?.fields || data) || [];
    const translatable = allFields.filter(
      (f) => isTranslatableField(f) && hasEnglishValue(f)
    );

    if (targetLocales.length === 0 || translatable.length === 0) {
      setErrorMessage('Nothing to translate — add English content first');
      setSeverity('warning');
      setOpenSnackbar(true);
      return;
    }

    if (!showAllLocales) setShowAllLocales(true);
    setBulkTranslating(true);
    try {
      // Run fields sequentially to keep Google Translate request volume in check,
      // but fan out the locales within each field in parallel.
      for (const field of translatable) {
        await Promise.all(
          targetLocales.map((locale) => onTranslateClick(field.id, locale, field, true))
        );
      }
      setErrorMessage(
        `Translated ${translatable.length} field${translatable.length > 1 ? 's' : ''} into ${targetLocales.length} locale${targetLocales.length > 1 ? 's' : ''}`
      );
      setSeverity('success');
      setOpenSnackbar(true);
    } finally {
      setBulkTranslating(false);
    }
  };

  // const handleChange = (id, value) => {
  //   setFormData((prevData) => ({ ...prevData, [id]: value }));
  // };

  // const handleChange = (id, value, condition = false) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     ...(condition ? {
  //       data: {
  //         ...prevData.data,
  //         [id]: value
  //       }
  //     } : {})
  //   }));
  // };

  useEffect(() => {
    if (!currentWorkspace || (Array.isArray(currentWorkspace) && currentWorkspace.length === 0)) {
      dispatch(getSpecificWorkspace(workspaceId));
    }
  }, [workspaceId, currentWorkspace, dispatch]);

  useEffect(() => {
    if (currentWorkspace?.data?.locales && currentWorkspace.data.locales.length > 0) {
      setSpaceLocales(currentWorkspace.data.locales);
    }
  }, [currentWorkspace]);

  useEffect(() => {
    if (versionPanelOpen && workspaceId && id) {
      dispatch(getEntryVersions(workspaceId, id));
    }
  }, [versionPanelOpen, workspaceId, id, dispatch]);

  useEffect(() => {
    if (!isDrawer) {
      const pathParts = location.pathname.split('/');
      const isEdit = pathParts.includes('edit-entry');
      if (isEdit && !isDrawerEdit && lastFetchedEntryId.current !== id) {
        lastFetchedEntryId.current = id;
        dispatch(getEntryForEdit(workspaceId, id));
        setIsEntriesFetched(true)
      }
    }
  }, [location.pathname, workspaceId, id, dispatch, isDrawer, isDrawerEdit]);

  useEffect(() => {
    if (!isDrawer && !isDrawerEdit) {
      const pathParts = location.pathname.split('/');
      const isEdit = pathParts.includes('edit-entry');

      if (isEdit && entry?.contentTypeId && isEntriesFetched) {
        setIsEditMode(true);
        dispatch(getContentTypeForEntry(workspaceId, entry.contentTypeId));
      }
    }
  }, [entry, location.pathname, workspaceId, dispatch, isDrawer, isEntriesFetched, isDrawerEdit]);

  useEffect(() => {
    if (isEditMode) {
      const publishStatus = isDrawerEdit
        ? editEntry?.entry?.published
        : entry?.published;
      setIsPublished(!!publishStatus);

      const scheduleSource = isDrawerEdit ? editEntry?.entry : entry;
      setScheduleInfo({
        scheduledAt: scheduleSource?.scheduledAt || null,
        scheduledUnpublishAt: scheduleSource?.scheduledUnpublishAt || null,
      });
    }
  }, [isEditMode, editEntry, entry, isDrawerEdit]);


  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const isCreate = pathParts.includes('create-entry');
    if (isCreate) {
      if (!contentType?.length > 0) {
        if (currentContentId) {
          dispatch(getContentTypeForEntry(workspaceId, currentContentId));
        } else {
          dispatch(getContentTypeForEntry(workspaceId, id));
        }
      }
      setIsEditMode(false);
      setIsCreateMode(true);
      setLoading(false);
      setIsInitialized(true);
    }

  }, [location.pathname, isDrawer, dispatch, workspaceId, id]);

  // Track changes in formData
  useEffect(() => {
    if (Object.keys(formData).length > 0 && !initialFormDataRef.current.identifier && !isCreateMode) {
      // Set initial form data when formData is first populated
      initialFormDataRef.current = { ...formData };
    }
    // Compare current formData with initial formData to determine if dirty
    const isFormDirty = !isEqual(formData, initialFormDataRef.current);

    setIsDirty(isFormDirty);
  }, [formData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  const [isInitialized, setIsInitialized] = useState(isDrawer ? true : false);
  const prevEntryRef = useRef();

  useEffect(() => {
    const initializeFormData = async () => {
      if (isDrawer) {
        setIsInitialized(true);
        setLoading(false);
        return;
      }
      if (isDrawerEdit || editEntry) {
        setLoading(false); // Ensure loading is stopped even if we return early
        return;
      }
      try {
        // if (!isEditMode) {
        //   setFormData({ identifier: '', references: {} });
        //   setIsInitialized(true);
        //   return;
        // }
        if (entry?.identifier !== prevEntryRef.current?.identifier && isEditMode && !isDrawer) {
          setLoading(true);
          if (entry && isEditMode && data) {
            const initialFormData = {
              identifier: entry.identifier,
              ...entry.data
            };

            // Handle localized content
            if (entrySelector.localeContent?.length > 0) {
              entrySelector.localeContent.forEach((localeData) => {
                const locale = localeData.locale;
                Object.entries(localeData).forEach(([key, value]) => {
                  if (key !== '_id' && key !== 'locale') {
                    initialFormData[key] = initialFormData[key] || {};
                    if (key.startsWith('richtext')) {
                      initialFormData[key][locale] = Array.isArray(value) ? value : [];
                    } else {
                      initialFormData[key][locale] = value;
                    }
                  }
                });
              });
            }

            // Handle references
            if (entry.references && entrySelector.references?.[0]) {
              const referencesWithEntries = {};

              Object.entries(entry.references).forEach(([fieldId, referenceIds]) => {
                referencesWithEntries[fieldId] = [];

                const formattedRefIds = referenceIds;

                formattedRefIds.forEach(refId => {
                  const foundRef = entrySelector.references[0].find(ref =>
                    ref.id === refId && ref.entry
                  );
                  if (foundRef) {
                    referencesWithEntries[fieldId].push({
                      _id: foundRef.entry._id,
                      identifier: foundRef.entry.identifier,
                      published: foundRef.entry.published,
                      contentTypeId: foundRef.entry.contentTypeId,
                      data: foundRef.entry.data || {},
                      localeData: foundRef.entry.localeData || {},
                      content_type_name: foundRef.entry.content_type_name
                    });
                  }
                });
              });

              setSelectedRefs(referencesWithEntries);
              initialFormData.references = referencesWithEntries;
            }

            console.log('INITALFORM DATA : ', initialFormData);
            prevEntryRef.current = entry;

            setFormData(initialFormData);
            // Setting initialFormDataRef to check whether form has been saved, for the purpose of form dirty check
            initialFormDataRef.current = { ...initialFormData };
            setIsNestedCreate(true);
            setRichTextState({ isReady: true, isDataLoaded: true });
            setIsInitialized(true);
          } else {
            setLoading(false);
            setIsInitialized(true);
          }
        }
      } catch (error) {
        console.error('Error initializing form data:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeFormData();

    // return () => {
    //   if (!isEditMode) {
    //     setFormData({});
    //     setSelectedRefs({});
    //     setIsInitialized(false);
    //     prevEntryRef.current = null;
    //   }
    // };
  }, [entry, isEditMode, isDrawer, data]);

  useEffect(() => {
    if (!contentType) {
      return () => {
        dispatch(resetForm());
        setFormData({});
        setSelectedRefs({});
        setIsInitialized(false);
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (contentType) {
      setContentId(contentType.contentType._id);
    }
  }, [location, contentType]);


  // const handleArrayChange = (id, locale, index, value) => {
  //   setFormData(prevData => {
  //     const newData = { ...prevData };
  //     if (!newData[id]) {
  //       newData[id] = {};
  //     }
  //     if (!newData[id][locale]) {
  //       newData[id][locale] = [];
  //     }

  //     const updatedArray = [...(newData[id][locale] || [])];
  //     updatedArray[index] = value;
  //     newData[id] = {
  //       ...newData[id],
  //       [locale]: updatedArray
  //     };

  //     if (updatedArray.some(item => item && item.trim())) {
  //       setErrors(prev => ({
  //         ...prev,
  //         [id]: locale ? {
  //           ...(prev[id] || {}),
  //           [locale]: ''
  //         } : ''
  //       }));
  //     }

  //     console.log(newData);
  //     return newData;
  //   });
  // };

  const handleArrayChange = (id, locale, index, value) => {
    setFormData(prevData => {
      const newData = { ...prevData };

      if (locale) {
        // Store under locale if locale is provided
        if (!newData[id]) {
          newData[id] = {};
        }
        if (!newData[id][locale]) {
          newData[id][locale] = [];
        }

        const updatedArray = [...(newData[id][locale] || [])];
        updatedArray[index] = value;
        newData[id] = {
          ...newData[id],
          [locale]: updatedArray
        };
      } else {
        // Store as raw array when locale is null
        if (!newData[id]) {
          newData[id] = [];
        }

        const updatedArray = [...(newData[id] || [])];
        updatedArray[index] = value;
        newData[id] = updatedArray;
      }

      // Handle errors
      if ((locale && newData[id][locale].some(item => item && item.trim())) ||
        (!locale && newData[id].some(item => item && item.trim()))) {
        setErrors(prev => ({
          ...prev,
          [id]: locale ? {
            ...(prev[id] || {}),
            [locale]: ''
          } : ''
        }));
      }

      return newData;
    });
  };

  useEffect(() => {
    const fields = contentType?.contentType?.fields || data || [];

    // Added debounce so it doesnt fire the for each type
    const updateSlug = debounce((field, refVal) => {
      setFormData((prev) => ({
        ...prev,
        [field.id]: {
          ...prev[field.id],
          en: refVal ? slugify(refVal) : "",  // clear when empty
        },
      }));
    }, 300);

    fields.forEach((field) => {
      if (
        field.type === "string" &&
        field.variant === "slugField" &&
        field.referenceSlugEntry && !isEditMode
      ) {
        const refVal = formData?.[field.referenceSlugEntry]?.en ?? "";

        if (!manualSlugEdits[field.id]) {
          updateSlug(field, refVal);
        }
      }
    });
    // cleanup to avoid memory leaks
    return () => updateSlug.cancel();
  }, [formData, contentType, data, manualSlugEdits, setFormData]);



  const handleArrayDelete = (id, locale, indexToDelete) => {
    setFormData(prevData => {
      const newData = { ...prevData };
      if (locale) {
        if (newData[id]?.[locale]) {
          newData[id][locale] = newData[id][locale].filter((_, index) => index !== indexToDelete);
        }
      } else {
        if (newData[id]) {
          newData[id] = newData[id].filter((_, index) => index !== indexToDelete);
        }
      }

      return newData;
    });
  };

  function safeParseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      // console.error("Invalid JSON string:", error);
      return null; // or handle in another way
    }
  }

  // Initialize fields for array type fields
  useEffect(() => {
    const initialFields = {};
    data?.forEach((field) => {
      if (field.type === "array") {
        initialFields[field.id] = [""]; // Initialize with one empty field for array fields
      }
    });
    setFields(initialFields);
  }, [data]);

  const openModal = (fieldId) => {
    setAddExistingEntryPopup({
      open: true,
      fieldId
    });
  };

  // AI generate-entry modal state.
  const [aiGenerateOpen, setAiGenerateOpen] = useState(false);
  // Drives a reference field's RightDrawer into controlled-open, pre-filled with
  // AI-drafted values, when the user clicks "Create with AI" for that field.
  const [aiRefCreate, setAiRefCreate] = useState(null); // { fieldId, contentTypeId, initialFormData } | null

  // Build wrapped initialFormData for a new referenced sub-entry from AI-generated
  // values, then open that field's drawer preset to the target content type.
  const onCreateReference = ({ fieldId, contentTypeId, generatedFields }) => {
    const targetCt = (allContentTypes || []).find((ct) => ct._id === contentTypeId);
    const targetFields = targetCt?.fields || [];
    const targetLocale = spaceLocales?.[0] || 'en';
    const initialFormData = { identifier: '' };
    targetFields.forEach((f) => {
      if (!generatedFields || !(f.id in generatedFields)) return;
      const value = generatedFields[f.id];
      const localized =
        f.type === 'string' ||
        f.type === 'richText' ||
        (f.type === 'array' && f.array_type === 'string') ||
        f.type === 'object';
      initialFormData[f.id] = localized ? { [targetLocale]: value } : value;
      // Suggest an identifier from the first generated plain-string field.
      if (!initialFormData.identifier && f.type === 'string' && typeof value === 'string') {
        initialFormData.identifier = value;
      }
    });
    setAiRefCreate({ fieldId, contentTypeId, initialFormData });
  };

  // Merge AI-generated field values into the form. Text-like (localized) fields
  // are stored per-locale; everything else is stored directly. Reference/media
  // fields are never generated — the user attaches those. Bumping _versionKey
  // remounts the rich-text editors so they pick up the new Slate values.
  const applyAiGeneratedFields = (fields) => {
    const fieldDefs = contentType?.contentType?.fields || data || [];
    const targetLocale = spaceLocales?.[0] || 'en';
    setFormData((prev) => {
      const next = { ...prev };
      fieldDefs.forEach((f) => {
        if (!fields || !(f.id in fields)) return;
        const value = fields[f.id];
        const localized =
          f.type === 'string' ||
          f.type === 'richText' ||
          (f.type === 'array' && f.array_type === 'string') ||
          f.type === 'object';
        if (localized) {
          next[f.id] = { ...(next[f.id] || {}), [targetLocale]: value };
        } else {
          next[f.id] = value;
        }
      });
      next._versionKey = Date.now();
      return next;
    });
    setIsDirty(true);
    setSuccessMessage('AI draft applied. Review the fields, attach references, and save when ready.');
    setSeverity('success');
    setOpenSnackbar(true);
  };

  // const handleRefChange = (value, fieldId) => {
  //   setSelectedRef(value);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [fieldId]: value,
  //   }));
  // };

  const handleReferenceAddEntry = async (selectedEntries, fieldId) => {
    try {
      setSelectedRefs(prev => {
        const prevEntriesForField = prev[fieldId] || [];

        const existingIds = new Set(prevEntriesForField.map(e => e._id));
        const newEntries = selectedEntries.filter(e => !existingIds.has(e._id));

        const updatedRefs = {
          ...prev,
          [fieldId]: [...prevEntriesForField, ...newEntries]
        };

        setFormData(prevFormData => ({
          ...prevFormData,
          references: updatedRefs
        }));

        if (updatedRefs[fieldId].length > 0) {
          setErrors(prev => ({
            ...prev,
            [fieldId]: ''
          }));
        }

        return updatedRefs;
      });
    } catch (error) {
      console.error('Error adding entries:', error);
    }
  };

  const handleEditReference = async (entry, fieldId) => {
    setEditIconLoading((prev) => ({
      ...prev,
      [entry?._id]: true,
    }));

    setReferenceEditing({
      isEditing: true,
      entryData: entry,
      fieldId: fieldId,
    });
  };

  useEffect(() => {
    if (!lastArrAdded) return;

    const { id, locale, index } = lastArrAdded;
    const inputEl = locale
      ? arrayFocusRefs.current[id]?.[locale]?.[index]
      : arrayFocusRefs.current[id]?.[index];

    if (inputEl) {
      inputEl.focus();
      setLastArrAdded(null); // Reset after focus
    }
  }, [formData, lastArrAdded]);


  useEffect(() => {
    const initializeDrawerEntry = async () => {
      setLoading(true);
      try {
        if (isDrawer && !versionPanelOpen) {
          setIsDrawerContext(true);
          if ((isDrawerEdit && editEntry)) {
            try {
              const formattedData = {
                identifier: editEntry?.entry?.identifier || "",
                ...editEntry?.entry?.data,
              };
              console.log('ENTRY SELECTOR : ', editEntry);

              if (editEntry.localeContent?.length > 0) {
                editEntry.localeContent.forEach((localeData) => {
                  const locale = localeData.locale;
                  Object.entries(localeData).forEach(([key, value]) => {
                    if (key !== '_id' && key !== 'locale') {
                      formattedData[key] = formattedData[key] || {};
                      if (key.startsWith('richtext')) {
                        formattedData[key][locale] = Array.isArray(value) ? value : [];
                      } else {
                        formattedData[key][locale] = value;
                      }
                    }
                  });
                });
              }

              if (editEntry.entry.references && editEntry.references?.[0]) {
                const referencesWithEntries = {};

                Object.entries(editEntry.entry.references).forEach(([fieldId, referenceIds]) => {
                  referencesWithEntries[fieldId] = [];

                  const formattedRefIds = referenceIds.map(id => {
                    if (typeof id === 'string') {
                      return id;
                    }
                    return id;
                  });

                  formattedRefIds.forEach(refId => {
                    const foundRef = editEntry.references[0].find(ref =>
                      ref.id === refId && ref.entry
                    );
                    if (foundRef) {
                      referencesWithEntries[fieldId].push({
                        _id: foundRef.entry._id,
                        identifier: foundRef.entry.identifier,
                        published: foundRef.entry.published,
                        contentTypeId: foundRef.entry.contentTypeId,
                        data: foundRef.entry.data || {},
                        localeData: foundRef.entry.localeData || {},
                        content_type_name: foundRef.entry.content_type_name
                      });
                    }
                  });
                });

                setSelectedRefs(referencesWithEntries);
                //initialFormData.references = referencesWithEntries;
              }
              console.log('Formatted Data : ', formattedData);

              setFormData(formattedData);
              setRichTextState({ isReady: true, isDataLoaded: true });
              setIsEditMode(true);
              setIsInitialized(true);

            } catch (error) {
              console.error('Error initializing drawer entry:', error);
            } finally {
              setLoading(false);
            }
          } else {
            setIsNestedCreate(true);
            setRichTextState({ isReady: true, isDataLoaded: true });
            // Seed from initialFormData when provided (AI "Create with AI" pre-fills
            // a new referenced sub-entry); otherwise start blank.
            if (initialFormData && Object.keys(initialFormData).length > 0) {
              const { references: seededRefs, ...rest } = initialFormData;
              setFormData({ ...rest, _versionKey: Date.now() });
              if (seededRefs) setSelectedRefs(seededRefs);
            } else {
              setFormData({});
            }
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }

    initializeDrawerEntry();
  }, [isDrawerEdit, editEntry, isDrawer]);


  useEffect(() => {
    if (Object.keys(selectedRefs).length > 0) {
      setFormData(prev => ({
        ...prev,
        references: selectedRefs
      }));
    }
  }, [selectedRefs]);

  const getContentTypeId = () => {
    if (isEditMode && entry?.contentTypeId) {
      return entry.contentTypeId;
    }
    return contentType?.contentType?._id || id;
  };

  // Fetch comment counts for badges (drawer keeps them fresh on its own actions)
  useEffect(() => {
    if (commentsEnabled && workspaceId && id) {
      dispatch(getCommentCounts(workspaceId, id));
    }
  }, [commentsEnabled, workspaceId, id, dispatch]);

  const openCommentsDrawer = (fieldAnchor = null) => {
    setCommentsFieldAnchor(fieldAnchor);
    setCommentsDrawerOpen(true);
  };

  // Switch reference entry order
  const handleDragEnd = (result, fieldId) => {
    if (!result.destination) return;

    const items = Array.from(selectedRefs[fieldId]);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSelectedRefs(prev => ({
      ...prev,
      [fieldId]: items
    }));
  };
  useEffect(() => {
    if (!isEditMode || versionPanelOpen || isVersionPreview) return;

    const entryId2 = isDrawerEdit ? editEntry?.entry?._id : entry?._id;
    if (!entryId2) return;

    const storedUser = localStorage.getItem('userInfo');
    if (!storedUser) return;

    const userObj = JSON.parse(storedUser);
    if (!userObj?._id) return;

    // Reset stale-write tracking when switching to a different entry — its data
    // is loaded fresh, so any previously seen save baseline no longer applies.
    // (Re-runs for the SAME entry, e.g. toggling the version panel, keep the
    // baseline so saves made meanwhile are still detected.)
    if (presenceEntryIdRef.current !== entryId2) {
      presenceEntryIdRef.current = entryId2;
      setStaleSave(null);
      delete lastSaveBaselineRef.current[entryId2];
    }

    const userRef = ref(db, `rooms/${entryId2}/users/${userObj._id}`);
    const roomUsersRef = ref(db, `rooms/${entryId2}/users`);
    const lastSaveRef = ref(db, `rooms/${entryId2}/lastSave`);

    // Mark user as present
    set(userRef, {
      name: userObj.name,
      joinedAt: serverTimestamp(),
      avatar: userObj.avatarUrl,
    });

    // Remove user if they disconnect/close tab
    onDisconnect(userRef).remove();

    // Listen for room users (keep the uid so the UI can exclude ourselves)
    const unsubscribe = onValue(roomUsersRef, (snapshot) => {
      const data = snapshot.val() || {};
      setUsers(Object.entries(data).map(([uid, u]) => ({ uid, ...u })));
    });

    // Listen for saves by other users. The first emission per entry reflects the
    // state at the time we opened it — the form data was loaded fresh, so only
    // saves arriving *after* that baseline are stale for us.
    const unsubscribeLastSave = onValue(lastSaveRef, (snapshot) => {
      const lastSave = snapshot.val();
      const baseline = lastSaveBaselineRef.current;
      if (!(entryId2 in baseline)) {
        baseline[entryId2] = lastSave?.at ?? null;
        return;
      }
      if (!lastSave) return;
      if (lastSave.by === userObj._id) {
        // Our own save landed — we hold the latest data again
        baseline[entryId2] = lastSave.at ?? null;
        setStaleSave(null);
      } else if (lastSave.at !== baseline[entryId2]) {
        setStaleSave({ name: lastSave.name || 'Another user', at: lastSave.at });
      }
    });

    // Cleanup
    return () => {
      remove(userRef);        // Remove current user
      unsubscribe();          // Remove listeners
      unsubscribeLastSave();
    };
  }, [
    isEditMode,
    isDrawerEdit,
    editEntry?.entry?._id,
    entry?._id,
    versionPanelOpen,
    isVersionPreview,
  ]);

  // const removeSelectedRef = (fieldId) => {
  //   setSelectedRef(""); // Clear the selected reference display
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [fieldId]: null, // Remove the reference from formData
  //   }));
  // };

  const renderLabel = (labelText, isRequired) => (
    <FormLabel
      component="legend"
      sx={{
        color: 'text.secondary',
        fontWeight: 600,
        fontSize: '0.875rem',
        mb: 1,
        display: 'block',
        '& .required': {
          color: 'error.main',
          marginLeft: '4px'
        }
      }}
    >
      {labelText}
      {isRequired && <span className="required">*</span>}
    </FormLabel>
  );

  const interpolateAiPrompt = (aiPrompt, formData, data) => {
    if (!aiPrompt) return '';

    // Regular expression to match field references like {field.fieldName} or {field.fieldName.es}
    const fieldRefRegex = /\{field\.([^}]+)\}/g;

    return aiPrompt.replace(fieldRefRegex, (match, fieldPath) => {
      const parts = fieldPath.split('.');
      const fieldName = parts[0];
      const requestedLocale = parts.length > 1 ? parts[1] : null;
      const field = data?.find(fId => fId.name === fieldName);
      // Determine which locale value to use
      const useLocale = requestedLocale;

      // Get the value for the determined locale
      const value = formData[field?.id]?.[useLocale] ||
        formData[field?.id]?.en ||
        match;

      return value;
    });
  };

  // Render AI according to conditions, this is a reusable function
  const renderAi = (field, id, locale) => {
    const interpolatedPrompt = interpolateAiPrompt(field.ai_prompt, formData, data);
    return (
      <div>
        <IconButton
          sx={{
            position: 'absolute',
            top: {
              xs: field.type === 'richText' ? 130 : 8,
              sm: field.type === 'richText' ? 100 : 8,
              md: field.type === 'richText' ? 80 : 8,
              lg: field.type === 'richText' ? 40 : 8
            },
            right: '30px',
            zIndex: 5,
            display: 'flex',
            alignItems: 'center',
            color: 'primary.main',
            backgroundColor: 'rgba(99, 102, 241, 0.05)',
            '&:hover': {
              backgroundColor: 'rgba(99, 102, 241, 0.1)',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease',
          }}
          className="group"
          onClick={() => onAiGenerateClick(interpolatedPrompt, id, locale, field)}
          disabled={aiLoading[`${id}-${locale}`] || !field.ai_prompt}
        >
          {aiLoading[`${id}-${locale}`] ? (
            <div className="flex space-x-1 mt-2">
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:0ms]"></span>
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:150ms]"></span>
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:300ms]"></span>
            </div>
          ) : (
            // <img src={Ai_Icon} className="w-4 opacity-70" alt="AI Icon" />
            <AutoAwesomeIcon sx={{ fontSize: 18 }} />
          )}
        </IconButton>


        <IconButton
          sx={{
            position: 'absolute',
            top: {
              xs: field.type === 'richText' ? 127 : 5,
              sm: field.type === 'richText' ? 97 : 8,
              md: field.type === 'richText' ? 77 : 5,
              lg: field.type === 'richText' ? 37 : 5
            },
            right: 0,
            zIndex: 5,
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          onClick={(e) => handleAiArrowClick(e, id, locale)}
        >
          <ArrowDropDownIcon />
        </IconButton>

        <Menu
          open={aiDropdown[`${id}-${locale}`] || false}
          onClose={() => handleAiCloseDropdown(id, locale)}
          anchorEl={aiAnchorEl[`${id}-${locale}`]}
          PaperProps={{
            className:
              "bg-white border text-gray-700 border-gray-300 rounded-md shadow-md",
          }}
          sx={{
            '& .MuiMenuItem-root': {
              fontSize: '0.875rem',
              py: 0,
            },
          }}
        >
          <MenuItem
            onClick={() => handleAiEditPrompt(field)}
            className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Edit prompt
          </MenuItem>
        </Menu>
      </div>
    )
  }

  // Render Translation button for non-English locales
  const renderTranslation = (field, id, locale) => {
    return (
      <IconButton
        sx={{
          position: 'absolute',
          top: {
            xs: field.type === 'richText' ? 130 : field.type === 'array' ? 15 : 8,
            sm: field.type === 'richText' ? 100 : field.type === 'array' ? 15 : 8,
            md: field.type === 'richText' ? 80 : field.type === 'array' ? 15 : 8,
            lg: field.type === 'richText' ? 40 : field.type === 'array' ? 15 : 8,
          },
          right: field.enable_ai
            ? '56px'
            : field.type === 'array'
              ? '45px'
              : field.specific_values
                ? '20px'
                : '5px',

          zIndex: 4,
          display: 'flex',
          alignItems: 'center',
          color: 'secondary.main',
          backgroundColor: 'rgba(16, 185, 129, 0.05)',
          '&:hover': {
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            transform: 'scale(1.1)',
          },
          transition: 'all 0.2s ease',
        }}
        className="group"
        onClick={() => onTranslateClick(id, locale, field)}
        disabled={translationLoading[`${id}-${locale}`]}
      >
        {translationLoading[`${id}-${locale}`] ? (
          <div className="flex space-x-1 mt-2">
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:0ms]"></span>
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:150ms]"></span>
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:300ms]"></span>
          </div>
        ) : (
          <img src={Translation_Icon} className="w-4 opacity-70" alt="Translation Icon" />
        )}
      </IconButton>
    );
  }


  const renderError = (fieldId, locale = null) => {
    const error = errors[fieldId];

    if (!error) return null;

    if (typeof error === 'object' && !Array.isArray(error)) {
      if (locale) {
        return error[locale] && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              display: 'block',
              mt: 0.5,
              ml: 1
            }}
          >
            {error[locale]}
          </Typography>
        );
      } else {
        const firstError = Object.values(error)[0];
        return firstError && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              display: 'block',
              mt: 0.5,
              ml: 1
            }}
          >
            This field is required
          </Typography>
        );
      }
    }

    return (
      <Typography
        variant="caption"
        color="error"
        sx={{
          display: 'block',
          mt: 0.5,
          ml: 1
        }}
      >
        {error}
      </Typography>
    );
  };

  const getFieldValue = (field, currentValue) => {
    const emptyRichText = [
      {
        type: 'paragraph',
        children: [{ text: '' }]
      }
    ];

    // For localized fields
    if (field.localizations) {
      const defaultValues = {};
      spaceLocales.forEach(locale => {
        // If current value exists for locale, use it
        if (currentValue?.[locale] !== undefined) {
          if (field.type === 'richText') {
            defaultValues[locale] = Array.isArray(currentValue[locale]) &&
              currentValue[locale].length > 0 ?
              currentValue[locale] :
              [...emptyRichText];
          } else {
            defaultValues[locale] = currentValue[locale];
          }
        } else {
          // Fallback to default value if no current value
          if (field.type === 'richText') {
            defaultValues[locale] = field.default_value ?
              JSON.parse(JSON.stringify(field.default_value)) :
              [...emptyRichText];
          } else {
            defaultValues[locale] = field.default_value || '';
          }
        }
      });
      return defaultValues;
    }

    // For non-localized fields
    if (currentValue !== undefined && currentValue !== null) {
      return currentValue;
    }

    // Fallback to default values if no current value
    if (field.type === 'string') {
      return { en: field.default_value || '' };
    }

    if (field.type === 'richText') {
      return field.default_value ?
        { en: [...field.default_value] } :
        { en: [...emptyRichText] };
    }

    return field.default_value ?? '';
  };


  const getDiffStyle = (id, locale, value) => {
    if (!compareWith || !diffType) return {};

    let otherValue;
    if (locale) {
      // Handle direct data or localeContent structure differences
      otherValue = compareWith.localeContent?.find(l => l.locale === locale)?.[id]
        ?? compareWith.entry?.data?.localeContent?.[locale]?.[id]
        ?? compareWith.entry?.localeContent?.[locale]?.[id];
    } else {
      otherValue = compareWith.entry?.data?.[id];
    }

    // Simplified equality check (convert both to string or JSON string if object)
    const valString = typeof value === 'object' ? JSON.stringify(value) : String(value || '');
    const otherValString = typeof otherValue === 'object' ? JSON.stringify(otherValue) : String(otherValue || '');

    if (valString !== otherValString) {
      if (diffType === 'current') {
        // Addition or Modification (Green)
        return {
          backgroundColor: '#e6ffec', // Light Green
          border: '1px solid #2e7d32',
          borderRadius: 1,
          p: 1,
          mb: 1
        };
      } else if (diffType === 'selected') {
        // Removal or Modification (Red)
        return {
          backgroundColor: '#ffebee', // Light Red
          border: '1px solid #c62828',
          borderRadius: 1,
          p: 1,
          mb: 1,
          opacity: 0.8
        };
      }
    }
    return {};
  };


  const renderInput = (field) => {
    const { id, name, type, required, localizations } = field;
    const locales = localizations
      ? (showAllLocales ? spaceLocales : ['en'])
      : primaryLocale;

    const fieldValue = getFieldValue(field, formData[id]);

    // If field is a slugField with reference
    const referenceFieldId = field.referenceSlugEntry;
    const referenceValue = referenceFieldId ? formData?.[referenceFieldId] : null;

    switch (type) {
      case "number":
        return (
          <Box sx={getDiffStyle(id, null, fieldValue)}>
            <FormControl fullWidth variant="outlined" component="fieldset">
              {renderLabel(name, required)}
              <TextField
                variant="outlined"
                fullWidth
                value={
                  fieldValue || ''
                }
                style={{ marginTop: "10px" }}
                onChange={(e) => {
                  const val = e.target.value;
                  handleChange(id, val === '' ? '' : parseFloat(val));
                }}
                onKeyPress={(e) => {
                  // Allow only numbers, decimal point, and control keys
                  if (!/[\d.]|\./g.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                    e.preventDefault();
                  }
                  // Prevent multiple decimal points
                  if (e.key === '.' && fieldValue?.includes('.')) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    padding: '8px',
                  },
                  '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: 'black',
                    color: 'black',
                  },
                }}
                disabled={isVersionPreview}
              />
              {renderError(id)}
            </FormControl>
          </Box>
        );

      case "string":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset" style={{ marginTop: "10px" }}>
            {renderLabel(name, required)}
            {(
              locales.map((locale) => (
                <Box key={`${id}-${locale}`} sx={{ position: 'relative', ...getDiffStyle(id, locale, fieldValue?.[locale]) }}>
                  {field.specific_values ? (
                    <FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
                      {field.localizations !== false && (
                        <InputLabel id={`${id}-${locale}-label`}
                          sx={{
                            fontSize: '16px',
                            transform: 'translate(14px, 8px) scale(1)',
                            '&.Mui-focused, &.MuiFormLabel-filled': {
                              transform: 'translate(14px, -6px) scale(0.75)',
                            },
                            color: '#7A7A7A',
                          }}
                        >({locale})</InputLabel>
                      )}
                      <Select
                        labelId={`${id}-${locale}-label`}
                        value={fieldValue?.[locale] || ''}
                        onChange={(e) => handleChange(id, e.target.value, locale)}
                        disabled={isVersionPreview}
                        label={field.localizations !== false ? `(${locale})` : ''}
                        size="small"
                        sx={{
                          '& .MuiInputBase-input': {
                            padding: '8px 14px',
                          },
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                      >
                        {field.specific_values.map((option) => (
                          <MenuItem
                            key={option}
                            value={option}
                            sx={{
                              fontSize: '1rem',
                              minHeight: '24px',
                              padding: '6px 6px',
                            }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : field.variant === 'longText' ? (
                    <Box sx={{ position: 'relative', mt: 1, mb: 0.5 }}>
                      {field.localizations !== false && (
                        <Typography
                          sx={{
                            position: 'absolute',
                            top: -8,
                            left: 10,
                            zIndex: 1,
                            bgcolor: 'white',
                            px: 1,
                            fontSize: '16px',
                            color: '#7A7A7A',
                          }}
                        >
                          ({locale})
                        </Typography>
                      )}
                      <StyledTextArea
                        value={fieldValue?.[locale] || ''}
                        onChange={(e) => handleChange(id, e.target.value, locale)}
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                        disabled={isVersionPreview}
                      />

                    </Box>
                  ) : field.variant === "slugField" ? (
                    <TextField
                      type="text"
                      label={field.localizations !== false ? `(${locale})` : ''}
                      variant="outlined"
                      fullWidth
                      value={fieldValue?.[locale] || ''}
                      style={{ marginBottom: "3px", marginTop: "10px" }}
                      onChange={(e) => {
                        // User manually typed → mark manual override
                        setManualSlugEdits(prev => ({ ...prev, [id]: true }));
                        handleChange(id, e.target.value, locale);
                      }}
                      sx={{
                        '& .MuiInputBase-root': { paddingY: '4px' },
                        '& .MuiInputBase-input': {
                          padding: '6px',
                          paddingY: '4px',
                          lineHeight: 1.5,
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px',
                          fontSize: '16px',
                          color: '#7A7A7A',
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: 'black',
                          color: 'black',
                        },
                      }}
                      disabled={isVersionPreview}
                    />
                  ) : (
                    <TextField
                      type="text"
                      label={field.localizations !== false ? `(${locale})` : ''}
                      variant="outlined"
                      fullWidth
                      value={fieldValue?.[locale] || ''}
                      style={{ marginBottom: "3px", marginTop: "10px" }}
                      onChange={(e) => handleChange(id, e.target.value, locale)}
                      sx={{
                        '& .MuiInputBase-root': {
                          paddingY: '4px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px',
                          paddingY: '4px',
                          lineHeight: 1.5,
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px',
                          fontSize: '16px',
                          color: '#7A7A7A',
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: 'black',
                          color: 'black',
                        },
                      }}
                      disabled={isVersionPreview}
                    />
                  )}
                  {field.enable_ai && renderAi(field, id, locale)}
                  {locale !== 'en' && renderTranslation(field, id, locale)}
                  {renderError(id, locale)}
                </Box>
              ))
            )}
          </FormControl>
        );

      case "richText":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {(!richTextState.isReady && !isCreateMode && !isNestedCreate) ? (
              <LoadingOverlay />
            ) : (
              locales.map((locale) => {
                // Ensure we have proper default content
                const defaultValue = [
                  {
                    type: 'paragraph',
                    children: [{ text: '' }]
                  }
                ];

                const fieldValue = getFieldValue(field, formData[field.id]);
                const currentValue = fieldValue?.[locale] || defaultValue;

                return (
                  <Box key={`${id}-${locale}-${formData._versionKey}`} className="relative" sx={getDiffStyle(id, locale, currentValue)}>
                    <FormLabel
                      component="legend"
                      sx={{
                        color: 'text.secondary',
                        fontWeight: 500,
                        mt: 1,
                        fontSize: '0.85rem',
                        '& .required': {
                          color: 'error.main',
                        }
                      }}
                    >
                      Locale : {locale}
                    </FormLabel>
                    <RichText
                      key={`${id}-${locale}`}
                      label={`(${locale})`}
                      type="richText"
                      value={currentValue}
                      onChange={(value) => handleChange(id, value, locale)}
                      locale={locale}
                      id={id}
                      disabled={isVersionPreview}
                    // initialExistingEntries={initialExistingEntries}
                    />
                    {field.enable_ai && renderAi(field, id, locale)}
                    {locale !== 'en' && renderTranslation(field, id, locale)}
                    {renderError(id, locale)}
                  </Box>
                );
              })
            )}
          </FormControl>
        );
      case "media":
        return (
          <div>
            <MediaUpload
              name={renderLabel(name, required)}
              workspaceId={workspaceId}
              value={formData[field.id] || []}
              onChange={(files) => handleChange(id, files)}
            />
            {renderError(id)}
          </div>
        );

      case "dateTime":
        return (
          <div>
            <DateTimeEntry
              name={renderLabel(name, required)}
              value={fieldValue || {
                date: '',
                time: '',
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
              }}
              onChange={(value) => handleChange(id, value)}
            />
            {renderError(id)}
          </div>
        );

      case "boolean":
        return (
          <div>
            <BooleanEntry
              name={renderLabel(name, required)}
              value={fieldValue}
              onChange={(value) => handleChange(id, value)}
            />
            {renderError(id)}
          </div>
        )

      case "color":
        return (
          <div>
            <ColorEntry
              name={renderLabel(name, required)}
              value={fieldValue}
              onChange={(value) => handleChange(id, value)}
              disabled={isVersionPreview}
            />
            {renderError(id)}
          </div>
        );

      case "object":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {field.display?.url ? (
              <iframe
                src={`${field.display.url}?data=${encodeURIComponent(JSON.stringify(fieldValue || {}))}`}
                style={{
                  width: "100%",
                  height: "500px",
                  border: "none",
                  borderRadius: "4px"
                }}
                title={field.display.appName}
                loading="lazy"
                onError={(e) => {
                  console.error("iframe loading error:", e);
                }}
              />
            ) : (
              locales.map((locale) => (
                <Box key={`${id}-${locale}`} sx={{ position: 'relative', mb: 2, ...getDiffStyle(id, locale, fieldValue?.[locale]) }}>
                  <FormLabel
                    component="legend"
                    sx={{
                      color: '#555555',
                      fontWeight: 400,
                      mt: 1,
                      fontSize: '0.85rem',
                      '& .required': {
                        color: '#d32f2f',
                      }
                    }}
                  >
                    Locale : {locale}
                  </FormLabel>
                  <JsonEditor
                    value={fieldValue[locale] != '' ? JSON.stringify(fieldValue[locale], null, 2) : ''}
                    onChange={(value) => handleChange(id, value, locale)}
                    disabled={isVersionPreview}
                  />
                  {renderError(id, locale)}
                </Box>
              ))

            )}
          </FormControl>
        );

      case "code":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            <Box sx={{ position: 'relative', mb: 2 }}>
              <CodeEditor
                value={fieldValue}
                onChange={(value) => handleChange(id, value)} // Assuming code fields are localized by default like string/richText logic or handle non-localized if needed. Let's check logic.
                // Actually logic above for string/richText handles non-localized by passing value directly or through locale map.
                // Re-reading getFieldValue helper: it returns object with locales if localized.
                // Let's stick to localized structure as it seems consistent for text-based fields.
                language={field.code_language || "javascript"}
                readOnly={isVersionPreview}
              />
              {/* renderAi and renderError inside box handled above? No wait. For non-localized: */}
              {field.enable_ai && renderAi(field, id, 'en')}
              {renderError(id, 'en')}
            </Box>

            {/* Note: I'm simplifying checks. The string/richText logic above uses `getFieldValue` and loops locales. I should probably do the same for consistency.
                 Re-doing this block to match 'richText' pattern more closely. */}
          </FormControl>
        );

      case "array":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {field.array_type === 'string' ? (

              locales.map((locale) => (
                <Accordion
                  key={locale}
                  defaultExpanded
                  sx={{
                    mt: 1.5,
                    '&:before': { display: 'none' },
                    boxShadow: 'none',
                    border: '1px solid rgba(226, 232, 240, 0.8)',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    ...getDiffStyle(id, locale, formData[id]?.[locale])
                  }}
                >
                  {field.localizations && (
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography color="primary">Locale: {locale}</Typography>
                    </AccordionSummary>
                  )}
                  <AccordionDetails>
                    {(formData[id]?.[locale] || [""]).map((value, index) => (
                      <Box
                        key={`${index}-${locale}`}
                        sx={{
                          display: 'flex',
                          gap: 1,
                          mb: 1,
                          alignItems: 'center'
                        }}
                      >
                        <TextField
                          inputRef={(el) => {
                            if (!arrayFocusRefs.current[id]) arrayFocusRefs.current[id] = {};
                            if (!arrayFocusRefs.current[id][locale]) arrayFocusRefs.current[id][locale] = {};
                            arrayFocusRefs.current[id][locale][index] = el;
                          }}
                          type="text"
                          variant="outlined"
                          fullWidth
                          placeholder={`Value ${index + 1}`}
                          //required={required}
                          value={value || ""}
                          onChange={(e) => handleArrayChange(id, locale, index, e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              const currentArray = formData[id]?.[locale] || [];
                              const newIndex = currentArray.length;
                              setLastArrAdded({ id, locale, index: newIndex });
                              handleArrayChange(id, locale, newIndex, "");
                            }
                          }}
                          size="small"
                          InputProps={{
                            sx: {
                              '& input::placeholder': {
                                fontSize: '0.975rem',
                              }
                            }
                          }}
                          sx={{
                            '& .MuiInputBase-input.Mui-disabled': {
                              WebkitTextFillColor: 'black',
                              color: 'black',
                            },
                          }}
                          disabled={isVersionPreview}
                        />
                        <IconButton
                          color="error"
                          onClick={() => handleArrayDelete(id, locale, index)}
                          size="small"
                          disabled={isVersionPreview}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    ))}
                    <Button
                      startIcon={<AddIcon />}
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        const currentArray = formData[id]?.[locale] || [];
                        handleArrayChange(id, locale, currentArray.length, "");
                      }}
                      sx={{
                        mt: 1,
                      }}
                      disabled={isVersionPreview}
                    >
                      Add Value
                    </Button>
                    {renderError(id, locale)}
                    {locale !== 'en' && renderTranslation(field, id, locale)}
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Accordion
                defaultExpanded
                sx={{
                  mt: 1,
                  '&:before': { display: 'none' },
                  boxShadow: 'none',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                }}
              >
                <AccordionDetails>
                  {(Array.isArray(formData[id]) ? formData[id] : [""]).map((value, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        gap: 1,
                        mb: 1,
                        alignItems: 'center'
                      }}
                    >
                      <TextField
                        inputRef={(el) => {
                          if (!arrayFocusRefs.current[id]) arrayFocusRefs.current[id] = {};
                          arrayFocusRefs.current[id][index] = el;
                        }}
                        variant="outlined"
                        value={value || ""}
                        fullWidth
                        required={required}
                        placeholder={`Value ${index + 1}`}
                        onChange={(e) => handleArrayChange(id, null, index, e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            const currentArray = formData[id] || [];
                            const newIndex = currentArray.length;
                            setLastArrAdded({ id, locale: null, index: newIndex });
                            handleArrayChange(id, null, newIndex, "");
                          }
                        }}
                        size="small"
                        InputProps={{
                          sx: {
                            '& input::placeholder': {
                              fontSize: '0.975rem',
                            }
                          }
                        }}
                        onKeyPress={(e) => {
                          // Allow only numbers, decimal point, and control keys
                          if (!/[\d.]|\./g.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                            e.preventDefault();
                          }
                          // Prevent multiple decimal points
                          if (e.key === '.' && value?.toString().includes('.')) {
                            e.preventDefault();
                          }
                        }}
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                        disabled={isVersionPreview}
                      />
                      <IconButton
                        color="error"
                        onClick={() => handleArrayDelete(id, null, index)}
                        size="small"
                        disabled={isVersionPreview}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      const currentArray = formData[id] || [];
                      handleArrayChange(id, null, currentArray.length, "");
                    }}
                    sx={{ mt: 1 }}
                    disabled={isVersionPreview}
                  >
                    Add Value
                  </Button>
                  {renderError(id, 'en')}
                </AccordionDetails>
              </Accordion>
            )}

          </FormControl>
        );
      case "reference":
        return (
          <>
            {renderLabel(name, required)}
            <Box sx={{
              border: '1px solid rgba(226, 232, 240, 0.8)',
              backgroundColor: 'rgba(248, 250, 252, 0.5)',
              alignItems: 'flex-start',
              p: 3,
              borderRadius: '16px'
            }}>
              <Box
                sx={{
                  width: '100%',
                  marginLeft: 0,
                  marginRight: 0,
                  alignItems: 'flex-start',
                  p: 1,
                  display: {
                    xs: 'block',
                    md: 'flex'
                  }
                }}
                alignItems="center"
                display={isMobile ? 'block' : "flex"}
                justifyContent="space-evenly">
                <Button
                  variant="outlined"
                  label="Add Existing Reference "
                  onClick={() => openModal(id)}
                  sx={{ width: { xs: '100%', md: '220px' } }}

                >+ Add Existing Reference</Button>
                <Typography color="secondary" align="center">or</Typography>

                <RightDrawer
                  contentTypeId={getContentTypeId()}
                  selectedRef={selectedRefs[id]}
                  setParentSelectedRef={setSelectedRefs}
                  fieldId={id}
                  editEntry={referenceEditing.isEditing && referenceEditing.fieldId === id ? referenceEditing.entryData : null}
                  isEditMode={referenceEditing.isEditing && referenceEditing.fieldId === id}
                  onEditClose={() => {
                    setReferenceEditing({
                      isEditing: false,
                      entryData: null,
                      fieldId: null
                    });
                    setEditIconLoading((prev) => ({
                      ...prev,
                      [referenceEditing?.entryData?._id]: false,
                    }));
                  }}
                  breadcrumbs={[
                    ...breadcrumbs,
                    isEditMode && editEntry ? editEntry.entry.identifier : (contentType?.contentType?.name || entryName)
                  ]}
                  controlledOpen={aiRefCreate?.fieldId === id}
                  presetContentTypeId={aiRefCreate?.fieldId === id ? aiRefCreate.contentTypeId : null}
                  presetInitialFormData={aiRefCreate?.fieldId === id ? aiRefCreate.initialFormData : null}
                  onControlledClose={() => setAiRefCreate(null)}
                />
              </Box>
              {Array.isArray(selectedRefs[id]) && selectedRefs[id]?.length > 0 && (
                <DragDropContext onDragEnd={(result) => handleDragEnd(result, id)}>
                  <StrictModeDroppable droppableId={id}>
                    {(provided) => (
                      <Box
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        sx={{ width: '100%' }}
                      >
                        {selectedRefs[id]?.map((entry, index) => (
                          <Draggable key={entry._id} draggableId={String(entry._id)} index={index}>
                            {(provided) => (
                              <Box
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                key={entry._id}
                                display="flex"
                                justifyContent="space-between"
                                sx={{
                                  width: '100%',
                                  marginBottom: 1,
                                  marginTop: 1,
                                  borderWidth: 1,
                                  borderColor: "#E6E6E6",
                                  borderStyle: "solid",
                                  p: 1,
                                  borderRadius: 2,
                                  transition: 'transform 0.3s ease, opacity 0.3s ease',
                                  bgcolor: 'background.paper',
                                }}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box {...provided.dragHandleProps} sx={{ display: 'flex', alignItems: 'center', cursor: 'grab', color: 'text.secondary' }}>
                                    <DragIndicatorIcon />
                                  </Box>
                                  <Stack spacing={0.5}>
                                    <Box display="flex" alignItems="center" gap={3}>
                                      <Tooltip title={entry.identifier} arrow>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            maxWidth: {
                                              xs: '100px',
                                              sm: '300px',
                                              md: '400px',
                                              lg: '550px',
                                            },
                                          }}
                                        >
                                          {entry.identifier}
                                        </Typography>
                                      </Tooltip>

                                      <Typography
                                        sx={{
                                          color: entry.published ? 'green' : '#856404',
                                          backgroundColor: entry.published ? '#e6ffe6' : '#fff3cd',
                                          padding: '2px 8px',
                                          borderRadius: '4px',
                                          fontSize: 13,
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {entry.published ? 'Published' : 'Draft'}
                                      </Typography>
                                    </Box>

                                    <Typography variant="body2" color="text.secondary">
                                      {allContentTypes.find(ct => ct._id === entry.contentTypeId)?.name || '...............'}
                                    </Typography>
                                  </Stack>
                                </Box>

                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                  <IconButton
                                    onClick={() => {
                                      handleEditReference(entry, id);
                                    }}
                                    disabled={editIconLoading[entry._id]}
                                  >
                                    {editIconLoading[entry._id] ? (
                                      <CircularProgress size={20} />
                                    ) : (
                                      <img
                                        src={editIcon}
                                        alt="edit icon"
                                        style={{ width: '20px', height: '20px' }}
                                      />
                                    )}
                                  </IconButton>
                                  <IconButton
                                    color="secondary"
                                    onClick={() => setSelectedRefs(prev => ({
                                      ...prev,
                                      [id]: prev[id].filter(e => e._id !== entry._id)
                                    }))}
                                    aria-label="delete"
                                  >
                                    <img
                                      src={DeleteIcon}
                                      alt="delete icon"
                                      style={{ width: '20px', height: '20px' }}
                                    />
                                  </IconButton>
                                </Box>
                              </Box>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </Box>
                    )}
                  </StrictModeDroppable>
                </DragDropContext>
              )}
            </Box>
            {renderError(id)}

            {/* <AddReferrenceModal
              isOpen={modalOpen}
              onClose={() => {
                setModalOpen(false)
              }}
              onChange={(value) => handleRefChange(value, name)}
            /> */}
            <AddExistingEntryPopup
              open={addExistingEntryPopup.open}
              onClose={() => setAddExistingEntryPopup({ open: false, fieldId: null })}
              onConfirm={(selectedIds) => handleReferenceAddEntry(selectedIds, addExistingEntryPopup.fieldId)}
            // initialExistingEntries={initialExistingEntries}
            />
          </>
        );

      default:
        return null;
    }
  };

  // useEffect(() => {
  //   console.log('SELECTED REFS : ', selectedRefs);

  // }, [selectedRefs])

  const validateField = (field, value) => {
    if (field.required) {

      if (value === undefined || value === null) {
        return 'This field is required';
      }

      switch (field.type) {
        case 'richText':
          const hasContent = (content) => {
            if (Array.isArray(content)) {
              return content.some(node => {
                console.log(content);

                // Check for numbered-list, paragraph, bulleted-list, or table-row
                if (['list-item', 'numbered-list', 'paragraph', 'bulleted-list', 'table', 'link', 'hr', 'heading-one', 'heading-two', 'heading-three', 'heading-four'].includes(node?.type)) {
                  return node?.children?.some(child => {
                    if (node?.type === 'table-row') {
                      // For table-row, check table-cell children
                      return child?.type === 'table-cell';
                    } else if (['paragraph', 'heading-one', 'heading-two', 'heading-three', 'heading-four'].includes(node?.type)) {
                      return child?.text?.trim().length > 0 ||
                        (child?.type === 'link' && child.children.some(c => c.text?.trim().length > 0));
                    } else {
                      return true;
                    }
                  });
                }
                return false;
              });
            }

            if (content && typeof content === 'object') {
              return Object.values(content).some(localeContent =>
                Array.isArray(localeContent) && localeContent.some(node => {
                  if (['list-item', 'numbered-list', 'paragraph', 'bulleted-list', 'table-row', 'link', 'hr', 'heading-one', 'heading-two', 'heading-three', 'heading-four'].includes(node?.type)) {
                    return node?.children?.some(child => {
                      if (node?.type === 'table-row') {
                        return child?.type === 'table-cell';
                      } else if (['paragraph', 'heading-one', 'heading-two', 'heading-three', 'heading-four'].includes(node?.type)) {
                        return child?.text?.trim().length > 0 ||
                          (child?.type === 'link' && child.children.some(c => c.text?.trim().length > 0));
                      } else {
                        return true;
                      }
                    });
                  }
                  return false;
                })
              );
            }

            return false;
          };


          if (field.localizations) {
            // Only check English locale for required validation
            const englishValue = value?.['en'];
            if (!hasContent(englishValue)) {
              return {
                en: 'This field is required' // Only return error for English
                // Other locales won't have errors for being empty
              };
            }
          } else if (!hasContent(value)) {
            return 'This field is required';
          }
          return '';

        case 'string':
          if (field.localizations) {
            // Only validate English locale for required fields
            const englishValue = value?.['en'];
            if (!englishValue || (typeof englishValue === 'string' && !englishValue.trim())) {
              return {
                en: 'This field is required' // Only English is required
              };
            }
          } else {
            if (!value ||
              (typeof value === 'string' && !value.trim()) ||
              (typeof value === 'object' && (!value.en || !value.en.trim()))) {
              return 'This field is required';
            }
          }
          return '';

        case 'dateTime':
          if (!value?.date || !value?.time) {
            return 'This field is required';
          }
          return '';

        case 'array':
          if (field.array_type === 'number') {
            const enValue = value || [];

            if (!enValue || !Array.isArray(enValue) || enValue.length === 0) {
              return 'This field is required';
            }
            return '';
          }

          const englishArray = Array.isArray(value?.en) ? value.en : [];

          if (englishArray.length === 0 || !englishArray.some(item => item && item.trim())) {
            return field.localizations
              ? { en: 'This field is required' }
              : 'This field is required';
          }
          return '';

        case 'reference':
          if (!value || !Array.isArray(value) || value.length === 0) {
            return 'This field is required';
          }
          return '';

        case 'boolean':
          if (value === undefined || value === null || value === '') {
            return 'This field is required';
          }
          return '';

        default:
          if (field.localizations) {
            // Only check English locale for default field types
            const englishValue = value?.['en'];
            if (!englishValue || (typeof englishValue === 'string' && !englishValue.trim())) {
              return {
                en: 'This field is required' // Only English is required
              };
            }
            return '';
          } else {
            // Non-localized field validation
            if (!value ||
              (typeof value === 'string' && !value.trim()) ||
              (typeof value === 'number' && isNaN(value))) {
              return 'This field is required';
            }
          }
          return '';
      }
    }
    return '';
  };

  // Tell other editors in the room that this entry was just saved (stale-write signal).
  // Best-effort — a Firebase failure must never affect the save itself.
  const broadcastSave = (entryId) => {
    if (!currentUserId) return;
    try {
      const storedUser = JSON.parse(localStorage.getItem('userInfo')) || {};
      set(ref(db, `rooms/${entryId}/lastSave`), {
        by: currentUserId,
        name: storedUser.name || '',
        at: serverTimestamp(),
      });
    } catch (err) {
      console.error('Failed to broadcast save to presence room:', err);
    }
  };

  const handleSubmit = async (e, status, isPreview, skipStaleCheck = false) => {
    if (isVersionPreview) return;
    e.preventDefault();

    // Stale-write guard: someone else saved this entry after we opened it —
    // confirm before overwriting their changes.
    if (isEditMode && staleSave && !skipStaleCheck) {
      pendingSubmitRef.current = { status, isPreview };
      setStaleConfirmOpen(true);
      return;
    }

    const newErrors = {};
    let hasError = false;

    if (!formData.identifier?.trim()) {
      newErrors.identifier = 'Identifier is required';
      hasError = true;
    }


    console.log('Starting validation...');

    // Validate all fields
    (contentType?.contentType?.fields || data)?.forEach((field) => {
      const fieldValue = getFieldValue(field, formData[field.id]);

      // Then check required fields
      if (field.required) {
        if (field.type === 'reference') {
          if (!selectedRefs[field.id] || selectedRefs[field.id].length === 0) {
            newErrors[field.id] = 'This field is required';
            hasError = true;
          }
        } else {
          const error = validateField(field, fieldValue);
          if (error) {
            newErrors[field.id] = error;
            hasError = true;
          }
        }
      }

      if (field.type === 'array' && field.array_type === 'number') {
        const arrayValue = formData[field.id]?.['en'] || [];
        if (arrayValue.length > 0) {
          const isValidNumber = arrayValue.some(item =>
            /^-?\d+(\.\d+)?$/.test(item)
          );
          if (!isValidNumber) {
            newErrors[field.id] = 'Please enter a valid number';
            hasError = true;
            return;
          }
        }
      }

      // Check regular number field validation
      if (field.type === 'number') {
        if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
          const isValidNumber = /^-?\d+(\.\d+)?$/.test(fieldValue);
          if (!isValidNumber) {
            newErrors[field.id] = 'Please enter a valid number';
            hasError = true;
          }
        }
      }
    });

    setErrors(newErrors);

    if (hasError) {
      setErrorMessage("Please fill in all required fields");
      setOpenSnackbar(true);
      setSeverity("error");
      return;
    }

    if (isPreview) {
      setSavePreviewLoading(true)
    } else {
      if (status === true) {
        setPublishLoading(true);
      } else {
        setPublishDraftLoading(true);
      }
    }
    try {
      if (formRef.current.reportValidity()) {
        const referenceFields = (contentType?.contentType?.fields || data).filter(
          field => field.type === "reference"
        );

        const references = {};
        referenceFields.forEach(field => {
          if (selectedRefs[field.id]) {
            references[field.id] = selectedRefs[field.id].map(ref => ref._id);
          }
        });


        const formattedData = {
          identifier: formData.identifier,
          data: {},
          localeData: {},
          references,
          workspaceId: workspaceId,
          contentTypeId: getContentTypeId(),
          version: isEditMode ? (isDrawerEdit ? editEntry.entry.version : entry.version) : 1,
          ...(isEditMode ? {} : { published: status }),
        };

        console.log('FORMATTED DATA : ', formattedData);


        (contentType?.contentType?.fields || data)?.forEach((field) => {
          const fieldValue = formData[field.id];

          if (field.type == 'string' || field.type == 'richText' || (field.type == 'array' && field.array_type == 'string') || field.type == 'object') {
            spaceLocales.forEach(locale => {
              if (!formattedData.localeData[locale]) {
                formattedData.localeData[locale] = {};
              }
              const localeValue = fieldValue?.[locale] ?? '';
              formattedData.localeData[locale][field.id] = localeValue;
            });
          } else {
            if (field.type == 'object') {
              formattedData.data[field.id] = fieldValue ?? "{}";
            } else {
              formattedData.data[field.id] = fieldValue;
            }
          }
        });

        try {
          if (isEditMode) {
            const entryId = isDrawerEdit ? editEntry.entry._id : entry._id;
            let response;
            if (isPreview) {
              response = await dispatch(updatePreviewEntryData(entryId, formattedData))
            } else {
              response = await dispatch(updateEntryData(entryId, formattedData))
            }
            if (response?.status === "success") {
              const newEntry = {
                _id: response.entryId,
                identifier: formattedData.identifier,
                published: status,
                contentTypeId: getContentTypeId(),
                content_type_name: contentType?.contentType?.name,
                ...response.entry
              };

              broadcastSave(entryId);
              setSuccessMessage("Entry Edited Successfully");
              setIsDirty(false);
              setOpenSnackbar(true);
              setSeverity("success");
              //dispatch(getEntryForEdit(workspaceId, id));
              if (onConfirm) {
                onConfirm(newEntry);
              }
            } else if (response?.conflict) {
              setErrorMessage(getFriendlyErrorMessage(response.message));
              setOpenSnackbar(true);
              setSeverity("error");

            } else {
              setErrorMessage(getFriendlyErrorMessage(response?.message));
              setOpenSnackbar(true);
              setSeverity("error");
            }

          } else {
            const response = await dispatch(submitFormData(formattedData));
            if (response?.status === "success") {
              const newEntry = {
                _id: response.entryId,
                identifier: formattedData.identifier,
                published: status,
                contentTypeId: getContentTypeId(),
                content_type_name: contentType?.contentType?.name,
                data: formattedData.data || {},
                localeData: formattedData.localeData || {},
                references: formattedData.references || {}
              };

              setSelectedRefs(prev => ({
                ...prev,
                [id]: [...(prev[id] || []), newEntry]
              }));

              setSuccessMessage("Entry Created");
              setIsDirty(false);
              setOpenSnackbar(true);
              setSeverity("success");

              if (!isDrawer) {
                navigate(`/${workspaceId}/edit-entry/${response.entryId}`);
              }

              if (onConfirm) {
                onConfirm(newEntry);
              }
            } else {
              setErrorMessage(getFriendlyErrorMessage(response?.message));
              setOpenSnackbar(true);
              setSeverity("error");
            }

          }
        } catch (error) {
          setErrorMessage(getFriendlyErrorMessage(error));
          setOpenSnackbar(true);
          setSeverity("error");
        }

      }
    } catch (error) {
      console.log('Please Try again.');
    } finally {
      if (status === true) {
        setPublishLoading(false);
      } else {
        setPublishDraftLoading(false);
      }
      setSavePreviewLoading(false);
    }
  };

  const handlePublishToggle = async (e) => {
    if (isVersionPreview) return;
    e.preventDefault();
    setPublishDraftLoading(true);

    try {
      const entryId = isDrawerEdit ? editEntry.entry._id : entry._id;
      const updateData = {
        identifier: formData.identifier,
        published: !isPublished,
        // ...formData
      };

      const response = await dispatch(updateEntryData(entryId, updateData));

      if (response?.status === "success") {
        setIsPublished(!isPublished);
        setSuccessMessage(`Entry ${!isPublished ? 'Published' : 'Unpublished'} Successfully`);
        setOpenSnackbar(true);
        setSeverity("success");

        if (onConfirm) {
          const updatedEntry = {
            ...editEntry.entry,
            published: !isPublished
          };

          if (referenceEditing.fieldId) {
            setSelectedRefs(prev => ({
              ...prev,
              [referenceEditing.fieldId]: prev[referenceEditing.fieldId].map(ref =>
                ref._id === updatedEntry._id ? { ...ref, published: !isPublished } : ref
              )
            }));
          }

          onConfirm(updatedEntry);
        }
      }
    } catch (error) {
      setErrorMessage(getFriendlyErrorMessage(error));
      setOpenSnackbar(true);
      setSeverity("error");
    } finally {

      setPublishDraftLoading(false);
    }
  };

  const handleScheduleSave = async (payload) => {
    setScheduleLoading(true);
    try {
      const entryId = isDrawerEdit ? editEntry.entry._id : entry._id;
      const response = await dispatch(scheduleEntryData(workspaceId, entryId, payload));

      if (response?.status === "success") {
        setScheduleInfo({
          scheduledAt: response.scheduledAt || null,
          scheduledUnpublishAt: response.scheduledUnpublishAt || null,
        });
        setSuccessMessage("Schedule updated successfully");
        setOpenSnackbar(true);
        setSeverity("success");
        setScheduleModalOpen(false);
      } else {
        setErrorMessage(response?.message || "Failed to update schedule");
        setOpenSnackbar(true);
        setSeverity("error");
      }
    } catch (error) {
      setErrorMessage(getFriendlyErrorMessage(error));
      setOpenSnackbar(true);
      setSeverity("error");
    } finally {
      setScheduleLoading(false);
    }
  };

  const handlePreviewClick = () => {
    if (!previewUrl) return;

    try {
      let finalUrl = previewUrl;

      const variablesToReplace = {
        '{entry.id}': id,
        '{contentType.id}': entry?.contentTypeId,
        '{workspace.id}': workspaceId
      };

      // Replace each specified variable if it exists in the URL
      Object.entries(variablesToReplace).forEach(([variable, value]) => {
        if (value && finalUrl.includes(variable)) {
          finalUrl = finalUrl.split(variable).join(value);
        }
      });

      // Basic validation to check if URL still contains any of the variables
      const remainingVariables = Object.keys(variablesToReplace)
        .filter(variable => finalUrl.includes(variable));

      if (remainingVariables.length > 0) {
        alert(`Missing values for: ${remainingVariables.join(', ')}`);
        return;
      }

      // Open the final URL
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error processing preview URL:', error);
      alert('Error processing preview URL');
    }
  }


  // useEffect(() => {
  //   if (Object.keys(selectedRefs).length > 0) {
  //     Object.entries(selectedRefs).forEach(([fieldId, refs]) => {
  //       if (refs?.length > 0) {
  //         setErrors(prev => ({
  //           ...prev,
  //           [fieldId]: ''
  //         }
  //         ))
  //       }
  //     }
  //     )
  //   }
  // })

  const isFieldValid = (field, value) => {
    if (!value) return false;

    switch (field.type) {
      case 'string':
      case 'richText':
        if (field.localizations) {
          return Object.values(value).some(v => v && v.length > 0);
        }
        return typeof value === 'string' && value.trim().length > 0;

      case 'number':
        return value !== null && value !== undefined && !isNaN(value);

      case 'dateTime':
        return value?.date && value?.time;

      case 'boolean':
        return value === true || value === false;

      case 'media':
        return Array.isArray(value) && value.length > 0;

      case 'array':
        return Array.isArray(value) && value.length > 0;

      case 'reference':
        return Array.isArray(value) && value.length > 0;

      default:
        return !!value;
    }
  };


  const handleChange = (id, value, locale) => {
    if (id === 'identifier') {
      setFormData(prev => ({
        ...prev,
        identifier: value
      }));

      if (value?.trim()) {
        setErrors(prev => ({
          ...prev,
          identifier: ''
        }));
      }
      return;
    }

    const field = (contentType?.contentType?.fields || data)?.find(f => f.id === id);
    if (field?.localizations && locale) {
      setModifiedLocaleFields(prev => ({
        ...prev,
        [id]: {
          ...(prev[id] || {}),
          [locale]: true
        }
      }));

      setFormData(prev => ({
        ...prev,
        [id]: {
          ...(prev[id] || {}),
          [locale]: value
        }
      }));
    } else {
      setModifiedFields(prev => ({
        ...prev,
        [id]: true
      }));

      let newValue;
      switch (field?.type) {
        case 'string':
          if (locale) {
            newValue = {
              ...formData[id],
              [locale]: value
            };
          } else {
            newValue = {
              ...(formData[id] || {}),
              en: value
            };
          }
          break;

        case 'object':
          newValue = locale ? {
            ...(formData[id] || {}),
            [locale]: value
          } : value;
          break;


        case 'richText':
          newValue = locale ? {
            ...formData[id],
            [locale]: value
          } : value;
          break;

        case 'boolean':
          newValue = value;
          break;

        default:
          newValue = locale ? {
            ...formData[id],
            [locale]: value
          } : value;
      }

      setFormData(prev => ({
        ...prev,
        [id]: newValue
      }));
    }

    // Clear errors if field is required and has value
    if (field?.required) {
      if (field.localizations) {
        // Only clear English errors for localized fields
        if (locale === 'en' && value?.trim?.()) {
          setErrors(prev => ({
            ...prev,
            [id]: {
              ...(prev[id] || {}),
              en: '' // Only clear English error
            }
          }));
        }
      } else if (value) {
        // Clear errors for non-localized fields
        setErrors(prev => ({
          ...prev,
          [id]: ''
        }));
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setErrorMessage("");
  };

  // Entry metadata for the header chip and sidebar cards
  const metaEntry = isDrawerEdit ? editEntry?.entry : entry;
  const workspaceUsers = currentWorkspace?.data?.user_details || [];
  const lastEditor = workspaceUsers.find(
    (u) => u._id === (metaEntry?.updatedBy || metaEntry?.createdBy)
  );
  const showSidebar = !isDrawerContext && !isVersionPreview;
  const actionBtnSx = {
    borderRadius: '10px',
    textTransform: 'none',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  };
  const outlinedBtnSx = {
    ...actionBtnSx,
    backgroundColor: 'white',
    borderColor: '#e2e8f0',
    color: 'text.primary',
    '&:hover': { borderColor: '#cbd5e1', backgroundColor: '#f8fafc' },
  };

  return (
    <div>
      <div className={`${isDrawerContext ? 'bg-white' : 'bg-[#f4f5fa]'} pt-5 pb-8 rounded-xl min-h-[calc(100vh-70px)]`}>
        <div className={isDrawerContext ? 'px-4 md:px-6' : 'max-w-[1440px] mx-auto px-4 md:px-10'}>
          {/* Back to entries */}
          {!isDrawerContext && !isVersionPreview && (
            <Button
              startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
              onClick={() => navigate(`/${workspaceId}/entries`)}
              sx={{
                textTransform: 'none',
                color: 'text.secondary',
                fontSize: '0.8125rem',
                mb: 1.5,
                px: 1,
                minWidth: 0,
                '&:hover': { backgroundColor: 'transparent', color: 'primary.main' },
              }}
            >
              Back to entries
            </Button>
          )}

          {/* Page header */}
          <div className="md:flex justify-between items-start gap-4">
            <div className="flex items-start gap-3.5 min-w-0">
              <div className="w-12 h-12 rounded-xl bg-[#7c70f2] flex items-center justify-center shrink-0">
                <EditOutlinedIcon sx={{ fontSize: 22, color: 'white' }} />
              </div>
              <div className="min-w-0">
                <h1 className="text-xl md:text-2xl font-bold text-slate-900 leading-tight">
                  {isEditMode ? 'Edit Entry' : 'Create Entry'}
                </h1>
                <div className="flex items-center gap-2 flex-wrap mt-1">
                  <p className="text-sm text-slate-500 truncate">
                    "{isEditMode
                      ? ((isEditMode && editEntry) ? editEntry.entry.identifier : entry?.identifier)
                      : (contentType?.contentType?.name || entryName)}"
                  </p>
                  {isEditMode && (
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${isPublished
                        ? 'bg-emerald-100 text-emerald-700'
                        : 'bg-amber-100 text-amber-700'
                        }`}
                    >
                      {isPublished ? 'Published' : 'Draft'}
                    </span>
                  )}
                </div>
                {isDrawer && (
                  <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2, mt: 0.5 }}>
                    {breadcrumbs.map((crumb, index) => (
                      <Typography key={index} color="text.secondary" fontSize="0.875rem">
                        {crumb}
                      </Typography>
                    ))}
                    <Typography color="text.primary" fontSize="0.875rem">
                      {isEditMode && editEntry ? editEntry.entry.identifier : (contentType?.contentType?.name || entryName)}
                    </Typography>
                  </Breadcrumbs>
                )}
                {entry?.previewSave === true && (
                  <div className="bg-orange-100 max-md:mr-4 md:w-[19rem] border-l-4 border-orange-500 max-md:text-xs md:text-sm mt-2 pl-2 text-orange-700 p-1 rounded-lg">
                    <p>Preview saved. Save to finalize changes.</p>
                  </div>
                )}
                {isEditMode && (scheduleInfo.scheduledAt || scheduleInfo.scheduledUnpublishAt) && (
                  <div className="bg-blue-50 max-md:mr-4 md:w-[19rem] border-l-4 border-blue-500 max-md:text-xs md:text-sm mt-2 pl-2 text-blue-700 p-1 rounded-lg">
                    {scheduleInfo.scheduledAt && (
                      <p>Scheduled to publish {new Date(scheduleInfo.scheduledAt).toLocaleString()}</p>
                    )}
                    {scheduleInfo.scheduledUnpublishAt && (
                      <p>Scheduled to unpublish {new Date(scheduleInfo.scheduledUnpublishAt).toLocaleString()}</p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap mt-4 md:mt-0 shrink-0" ref={saveButtonRef}>
              {!versionPanelOpen && !isVersionPreview && (
                isEditMode ? (
                  <>
                    <Button
                      variant="outlined"
                      startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 18 }} />}
                      onClick={handlePreviewClick}
                      disabled={!hasPermission('viewer') || !previewUrl}
                      sx={outlinedBtnSx}
                    >
                      Preview
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<MoreHorizIcon sx={{ fontSize: 18 }} />}
                      endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
                      onClick={handleDropdownClick}
                      sx={outlinedBtnSx}
                    >
                      More actions
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={handlePublishToggle}
                        disabled={publishDraftLoading || !hasPermission('editor')}
                        sx={{
                          '&.Mui-disabled': {
                            backgroundColor: 'white',
                            color: 'primary.main',
                            opacity: 0.7,
                          },
                        }}
                      >
                        {
                          publishDraftLoading ? (
                            <LoadingSpinner color="white" sx={{ marginRight: 1 }} />
                          ) : (
                            <img
                              src={CloudIcon}
                              alt="Status Toggle Icon"
                              style={{ width: 24, height: 24, marginRight: 1, color: 'primary.main' }}
                            />
                          )
                        }

                        {
                          publishDraftLoading
                            ? "Processing..."
                            : isPublished
                              ? "Unpublish"
                              : "Publish"
                        }
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleClose();
                          setScheduleModalOpen(true);
                        }}
                        disabled={!hasPermission('editor')}
                      >
                        <ScheduleIcon sx={{ marginRight: 1 }} />
                        Schedule Publishing
                      </MenuItem>
                      <Divider />
                      {!isDrawer && (
                        <MenuItem
                          onClick={() => setVersionPanelOpen(!versionPanelOpen)}
                          disabled={!hasPermission('editor')}
                        >
                          <HistoryIcon sx={{ marginRight: 1 }} />
                          Version Control
                        </MenuItem>
                      )}
                    </Menu>
                    {/* Save split button */}
                    <div className="flex">
                      <Button
                        variant="contained"
                        startIcon={publishLoading ? (<LoadingSpinner />) : (<img src={SaveDraftIcon} alt="save icon" style={{ width: 18, height: 18 }} />)}
                        onClick={(e) => handleSubmit(e, true, false)}
                        disabled={publishLoading || !hasPermission('editor')}
                        sx={{
                          ...actionBtnSx,
                          borderRadius: '10px 0 0 10px',
                          px: 2.5,
                          boxShadow: 'none',
                          '&:hover': { boxShadow: 'none' },
                          '&.Mui-disabled': {
                            backgroundColor: 'primary.main',
                            color: 'white',
                            opacity: 0.7,
                          },
                        }}
                      >
                        {publishLoading ? "Saving..." : "Save"}
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleSaveMenuClick}
                        disabled={!hasPermission('editor')}
                        sx={{
                          ...actionBtnSx,
                          borderRadius: '0 10px 10px 0',
                          minWidth: 0,
                          px: 1,
                          boxShadow: 'none',
                          borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
                          '&:hover': { boxShadow: 'none' },
                          '&.Mui-disabled': {
                            backgroundColor: 'primary.main',
                            color: 'white',
                            opacity: 0.7,
                          },
                        }}
                      >
                        <KeyboardArrowDownIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </div>
                    <Menu
                      anchorEl={saveMenuAnchorEl}
                      open={saveMenuOpen}
                      onClose={handleSaveMenuClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={(e) => {
                          handleSaveMenuClose();
                          handleSubmit(e, true, true);
                        }}
                        disabled={publishLoading || !hasPermission('editor')}
                      >
                        {
                          savePreviewLoading ? (
                            <div className="mr-3">
                              <LoadingSpinner color="white" style={{ marginRight: 2 }} />
                            </div>
                          ) : (
                            <PublishedWithChangesIcon sx={{ marginRight: 1 }} />
                          )
                        }
                        Save Preview
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      startIcon={<AutoAwesomeOutlinedIcon sx={{ fontSize: 18 }} />}
                      onClick={() => setAiGenerateOpen(true)}
                      disabled={!hasPermission('editor')}
                      sx={outlinedBtnSx}
                    >
                      AI Generate
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={
                        publishDraftLoading ? (
                          <LoadingSpinner color='primary.main' />
                        ) : (
                          <img src={SaveDraftIcon2} alt="Save Draft Icon" style={{ width: 18, height: 18 }} />
                        )
                      }
                      onClick={(e) => handleSubmit(e, false)}
                      disabled={publishDraftLoading}
                      sx={outlinedBtnSx}
                    >
                      {publishDraftLoading ? "Saving Draft..." : "Save Draft"}
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={
                        publishLoading ? (
                          <LoadingSpinner />
                        ) : (
                          <img src={CloudIcon2} alt="cloud icon" style={{ width: 18, height: 18 }} />
                        )
                      }
                      onClick={(e) => handleSubmit(e, true)}
                      disabled={publishLoading}
                      sx={{
                        ...actionBtnSx,
                        px: 3,
                        boxShadow: 'none',
                        '&:hover': { boxShadow: 'none' },
                        '&.Mui-disabled': {
                          backgroundColor: 'primary.main',
                          color: 'white',
                          opacity: 0.7,
                        },
                      }}
                    >
                      {publishLoading ? "Publishing..." : "Publish"}
                    </Button>
                  </>
                )
              )}
              {commentsEnabled && !versionPanelOpen && (
                <Tooltip title="Comments">
                  <IconButton onClick={() => openCommentsDrawer(null)}>
                    <Badge
                      badgeContent={
                        (commentCounts?.entry || 0) +
                        Object.values(commentCounts?.byField || {}).reduce((a, b) => a + b, 0)
                      }
                      color="primary"
                      max={99}
                    >
                      <ChatBubbleOutlineIcon color="primary" />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )}
              {isEditMode && !versionPanelOpen && !isVersionPreview && (
                <IconButton onClick={() => setInfoDrawerOpen(true)}>
                  <InfoIcon color="primary" />
                </IconButton>
              )}
            </div>
          </div>
          {isEditMode && !versionPanelOpen && !isVersionPreview && otherEditors.length > 0 && (
            <div className="mt-4 flex items-center justify-between gap-3 bg-indigo-50 border-l-4 border-indigo-500 rounded-lg px-3 py-2">
              <p className="text-sm text-indigo-700 font-medium">
                {otherEditors.length === 1
                  ? `${otherEditors[0].name} is editing this entry`
                  : `${otherEditors[0].name} and ${otherEditors.length - 1} other${otherEditors.length > 2 ? 's' : ''} are editing this entry`}
              </p>
              <Box display="flex" gap={1}>
                {otherEditors.map((u) => (
                  <Tooltip key={u.uid} title={u.name} arrow>
                    <Avatar
                      alt={u.name}
                      src={u.avatar}
                      sx={{ width: 32, height: 32, border: '2px solid #fff' }}
                    />
                  </Tooltip>
                ))}
              </Box>
            </div>
          )}
          {isEditMode && !versionPanelOpen && !isVersionPreview && staleSave && (
            <div className="mt-3 bg-amber-50 border-l-4 border-amber-500 rounded-lg px-3 py-2">
              <p className="text-sm text-amber-800 font-medium">
                {staleSave.name} saved this entry after you opened it.
              </p>
              <p className="text-xs text-amber-700 mt-0.5">
                Saving now may overwrite their changes — refresh to load the latest version first.
              </p>
            </div>
          )}
          {/* Body: content card + sidebar */}
          <div className="mt-6 lg:flex items-start gap-6">
            {/* Content Information card */}
            <div className="flex-1 min-w-0 bg-white border border-slate-200/80 rounded-2xl shadow-sm">
              <div className="flex items-start justify-between gap-4 px-5 md:px-8 pt-6 pb-4 border-b border-slate-100">
                <div>
                  <h2 className="text-base md:text-lg font-bold text-slate-900">Content Information</h2>
                  <p className="text-sm text-slate-500 mt-0.5">
                    {isEditMode ? 'Update the details for this entry' : 'Fill in the details for this entry'}
                  </p>
                </div>
                {/* Locale on/off toggle - Only show if at least one field has localizations */}
                {(contentType?.contentType?.fields || data)?.some(field => field.localizations) && (
                  <div className="flex items-center gap-3 shrink-0">
                    {spaceLocales.filter((l) => l !== 'en').length > 0 && (
                      <Tooltip title="Translate every localizable field into all locales">
                        <span>
                          <Button
                            variant="outlined"
                            size="small"
                            color="secondary"
                            disabled={bulkTranslating || isVersionPreview}
                            onClick={onTranslateWholeEntry}
                            startIcon={
                              bulkTranslating ? (
                                <CircularProgress size={14} color="inherit" />
                              ) : (
                                <img src={Translation_Icon} className="w-4" alt="" />
                              )
                            }
                            sx={{ textTransform: 'none', whiteSpace: 'nowrap', mt: 1 }}
                          >
                            {bulkTranslating ? 'Translating…' : 'Translate entry'}
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    <Tooltip title="Show localized fields">
                    <label className="relative inline-flex items-center cursor-pointer shrink-0 mt-1">
                      <input
                        type="checkbox"
                        value=""
                        className="sr-only peer"
                        onClick={() => setShowAllLocales(!showAllLocales)}
                        checked={showAllLocales}
                      />
                      <div className="group peer ring-0 bg-gray-200 rounded-full duration-300 after:duration-300 w-14 h-7 shadow-md peer-checked:bg-primary-main after:content-[''] after:rounded-full after:absolute after:bg-gray-50 after:h-5 after:w-5 after:top-1 after:left-1 after:flex after:justify-center after:items-center peer-checked:after:translate-x-7 peer-hover:after:scale-95">
                        {/* Right icon (ON state): Language */}
                        <Box className="absolute top-[4px] left-[32px] w-5 h-5 flex items-center justify-center text-gray-900">
                          <LanguageIcon sx={{ fontSize: '18px' }} />
                        </Box>

                        {/* Left icon (OFF state): Slashed Language */}
                        <Box className="absolute top-[4px] left-1 w-5 h-5 flex items-center justify-center text-gray-900">
                          <Box sx={{ position: 'relative', width: 16, height: 16 }}>
                            <Box className="absolute top-[-6px]">
                              <LanguageIcon sx={{ fontSize: '18px' }} />
                            </Box>
                            <Box
                              sx={{
                                position: 'absolute',
                                width: '110%',
                                height: 1.2,
                                backgroundColor: 'black',
                                top: '50%',
                                left: 0,
                                transform: 'rotate(45deg)',
                              }}
                            />
                          </Box>
                        </Box>
                      </div>
                    </label>
                    </Tooltip>
                  </div>
                )}
              </div>

              <form className="px-5 md:px-8 pb-6" ref={formRef}>
                {/* Identifier */}
                <div className="flex gap-3 py-5 border-b border-slate-100">
                  <div className="w-9 h-9 rounded-lg bg-indigo-50 text-indigo-500 flex items-center justify-center shrink-0">
                    <TagIcon sx={{ fontSize: 18 }} />
                  </div>
                  <div className="flex-1 min-w-0 relative">
                    {formData.identifier?.trim() && (
                      <CheckCircleOutlineIcon
                        sx={{ position: 'absolute', top: 2, right: 0, fontSize: 18, color: '#10b981' }}
                      />
                    )}
                    <FormControl fullWidth variant="outlined" component="fieldset">
                      {renderLabel('Identifier', true)}
                      <Typography variant="caption" sx={{ color: '#94a3b8', mt: -1, mb: 1, display: 'block' }}>
                        Unique slug or key for this entry.
                      </Typography>
                      <TextField
                        key="identifier"
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={formData.identifier}
                        onChange={(e) => handleChange("identifier", e.target.value)}
                        sx={{
                          '& .MuiInputBase-root': {
                            paddingY: '4px',
                          },

                          '& .MuiInputBase-input': {
                            padding: '6px',
                            paddingY: '4px',
                            lineHeight: 1.5,
                          },
                          '& .MuiInputLabel-root': {
                            top: '-8px',
                            fontSize: '16px',
                            color: '#7A7A7A',
                          },
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                        disabled={isVersionPreview}
                      />
                      {renderError("identifier")}
                    </FormControl>
                  </div>
                </div>
                {/* Content-type fields */}
                {(contentType?.contentType?.fields || data)?.map((field) => (
                  <div key={field.id} className="flex gap-3 py-5 border-b border-slate-100 last:border-0">
                    <FieldIconTile type={field.type} variant={field.variant} />
                    <div className="flex-1 min-w-0" style={{ position: 'relative' }}>
                      {commentsEnabled && !versionPanelOpen && (
                        <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 2 }}>
                          <FieldCommentBadge
                            count={commentCounts?.byField?.[field.id] || 0}
                            onClick={() => openCommentsDrawer({ fieldId: field.id, fieldName: field.name })}
                          />
                        </div>
                      )}
                      {showAllLocales &&
                        !versionPanelOpen &&
                        !isVersionPreview &&
                        isTranslatableField(field) &&
                        spaceLocales.filter((l) => l !== 'en').length > 0 && (
                          <Tooltip title="Translate this field into all locales">
                            <span
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: commentsEnabled && !versionPanelOpen ? 36 : 0,
                                zIndex: 2,
                              }}
                            >
                              <Button
                                size="small"
                                color="secondary"
                                disabled={fieldTranslating[field.id]}
                                onClick={() => onTranslateFieldAllLocales(field)}
                                startIcon={
                                  fieldTranslating[field.id] ? (
                                    <CircularProgress size={12} color="inherit" />
                                  ) : (
                                    <img src={Translation_Icon} className="w-3.5" alt="" />
                                  )
                                }
                                sx={{
                                  textTransform: 'none',
                                  minWidth: 0,
                                  py: 0.25,
                                  px: 0.75,
                                  fontSize: '0.7rem',
                                }}
                              >
                                {fieldTranslating[field.id] ? 'Translating…' : 'All locales'}
                              </Button>
                            </span>
                          </Tooltip>
                        )}
                      {renderInput(field)}
                    </div>
                  </div>
                ))}
              </form>
            </div>

            {/* Right sidebar */}
            {showSidebar && (
              <aside className="w-full lg:w-[320px] shrink-0 space-y-4 mt-6 lg:mt-0">
                {/* Status */}
                <SidebarCard title="Status">
                  {isEditMode ? (
                    <>
                      <Select
                        fullWidth
                        size="small"
                        value={isPublished ? 'published' : 'draft'}
                        onChange={(e) => {
                          const nextPublished = e.target.value === 'published';
                          if (nextPublished !== isPublished) handlePublishToggle(e);
                        }}
                        disabled={publishDraftLoading || !hasPermission('editor') || isVersionPreview}
                        IconComponent={KeyboardArrowDownIcon}
                        renderValue={(value) => (
                          <span className="flex items-center gap-2">
                            <span className={`w-2 h-2 rounded-full ${value === 'published' ? 'bg-emerald-500' : 'bg-amber-400'}`} />
                            <span className="text-sm font-semibold text-slate-800">
                              {value === 'published' ? 'Published' : 'Draft'}
                            </span>
                          </span>
                        )}
                        sx={{
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
                        }}
                      >
                        <MenuItem value="published" sx={{ fontSize: '0.875rem' }}>Published</MenuItem>
                        <MenuItem value="draft" sx={{ fontSize: '0.875rem' }}>Draft</MenuItem>
                      </Select>
                      <div className="mt-4 space-y-3">
                        <div className="flex items-center justify-between gap-3">
                          <span className="text-[13px] text-slate-500">Last updated</span>
                          <span className="text-[13px] text-slate-700 text-right">
                            {formatDateTime(metaEntry?.updatedAt || metaEntry?.createdAt) || '—'}
                          </span>
                        </div>
                        <div className="flex items-center justify-between gap-3">
                          <span className="text-[13px] text-slate-500">By</span>
                          {lastEditor ? (
                            <span className="flex items-center gap-1.5">
                              <Avatar src={lastEditor.avatarUrl} alt={lastEditor.name} sx={{ width: 20, height: 20 }} />
                              <span className="text-[13px] text-slate-700">{lastEditor.name}</span>
                            </span>
                          ) : (
                            <span className="text-[13px] text-slate-700">—</span>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <p className="text-sm text-slate-500">
                      This entry hasn't been saved yet. Publish it or save it as a draft.
                    </p>
                  )}
                </SidebarCard>

                {/* Entry details */}
                <SidebarCard title="Entry Details">
                  <div className="space-y-3.5">
                    <div className="flex items-center justify-between gap-3">
                      <span className="flex items-center gap-2 text-[13px] text-slate-500">
                        <GridViewOutlinedIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
                        Content type
                      </span>
                      <span className="text-[13px] text-slate-700 truncate">
                        {contentType?.contentType?.name || entryName || '—'}
                      </span>
                    </div>
                    <div className="flex items-center justify-between gap-3">
                      <span className="flex items-center gap-2 text-[13px] text-slate-500">
                        <LanguageIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
                        Workspace
                      </span>
                      <span className="flex items-center gap-1.5 text-[13px] text-slate-700 truncate">
                        <span className="w-2 h-2 rounded-full bg-[#7c70f2] shrink-0" />
                        {currentWorkspace?.data?.name || '—'}
                      </span>
                    </div>
                    {isEditMode && metaEntry?._id && (
                      <div className="flex items-center justify-between gap-3">
                        <span className="flex items-center gap-2 text-[13px] text-slate-500 shrink-0">
                          <KeyOutlinedIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
                          Entry ID
                        </span>
                        <span className="flex items-center gap-1 min-w-0">
                          <span className="inline-flex px-1.5 py-0.5 rounded-md bg-slate-100 text-slate-700 text-xs font-mono truncate">
                            #{String(metaEntry._id).slice(-6)}
                          </span>
                          <Tooltip title="Copy entry ID">
                            <IconButton size="small" onClick={() => handleCopyEntryId(metaEntry._id)}>
                              <ContentCopyIcon sx={{ fontSize: 14, color: '#94a3b8' }} />
                            </IconButton>
                          </Tooltip>
                        </span>
                      </div>
                    )}
                  </div>
                </SidebarCard>

                {/* Helpful tips */}
                <SidebarCard
                  title="Helpful Tips"
                  tinted
                  icon={<LightbulbOutlinedIcon sx={{ fontSize: 18, color: '#f59e0b' }} />}
                >
                  <ul className="space-y-2.5">
                    {[
                      'Use a clear and descriptive title.',
                      'Upload high-quality images for the best results.',
                      'Keep descriptions concise and relevant.',
                    ].map((tip) => (
                      <li key={tip} className="flex items-start gap-2">
                        <span className="text-slate-400 leading-5">•</span>
                        <span className="text-[13px] text-slate-600 leading-5">{tip}</span>
                      </li>
                    ))}
                  </ul>
                </SidebarCard>

                {/* Need help */}
                <SidebarCard
                  title="Need Help?"
                  icon={<HelpOutlineIcon sx={{ fontSize: 18, color: '#7c70f2' }} />}
                >
                  <div className="space-y-2.5">
                    <Link
                      component="button"
                      type="button"
                      underline="hover"
                      onClick={() => navigate('/documentation')}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        fontSize: '13px',
                        fontWeight: 500,
                        color: '#6366f1',
                      }}
                    >
                      Visit our documentation
                      <LaunchIcon sx={{ fontSize: 13 }} />
                    </Link>
                    <Link
                      href="mailto:content-cloud@cloudofgoods.com"
                      underline="hover"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        fontSize: '13px',
                        fontWeight: 500,
                        color: '#6366f1',
                      }}
                    >
                      Contact support
                      <LaunchIcon sx={{ fontSize: 13 }} />
                    </Link>
                  </div>
                </SidebarCard>
              </aside>
            )}
          </div>
        </div>
      </div>
      {!isVersionPreview && (
        <VersionDrawer
          open={versionPanelOpen}
          onClose={(e) => handleDrawerClose(e)}
          entry={entrySelector}
          contentType={data}
          onVersionSelect={(versionData) => {
            const timestamp = Date.now();
            setFormData({
              ...versionData,
              identifier: formData.identifier,
              _versionKey: timestamp
            });
          }}
        />
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {severity === "success" ? successMessage : errorMessage}
        </Alert>
      </Snackbar>
      {!isInitialized && !isCreateMode &&
        <LoadingOverlay />}

      {loading && <LoadingOverlay />}

      <AiEditPromptModal
        open={aiEditPromptPopupOpen}
        onClose={() => setAiEditPromptPopupOpen(false)}
        selectedField={selectedField}
        editContentTypeId={entry?.contentTypeId}
      />

      {/* Scheduled publishing */}
      {isEditMode && (
        <SchedulePublishModal
          open={scheduleModalOpen}
          onClose={() => setScheduleModalOpen(false)}
          schedule={scheduleInfo}
          isPublished={isPublished}
          onSave={handleScheduleSave}
          loading={scheduleLoading}
        />
      )}

      {/* Stale-write confirmation */}
      <Dialog
        open={staleConfirmOpen}
        onClose={() => {
          setStaleConfirmOpen(false);
          pendingSubmitRef.current = null;
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Overwrite recent changes?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {staleSave?.name || 'Another user'} saved this entry after you opened
            it. Saving now will overwrite their changes with what you see on
            screen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setStaleConfirmOpen(false);
              pendingSubmitRef.current = null;
            }}
          >
            Cancel
          </Button>
          <Button
            color="warning"
            variant="contained"
            onClick={() => {
              const pending = pendingSubmitRef.current;
              pendingSubmitRef.current = null;
              setStaleConfirmOpen(false);
              if (pending) {
                handleSubmit({ preventDefault: () => { } }, pending.status, pending.isPreview, true);
              }
            }}
          >
            Save anyway
          </Button>
        </DialogActions>
      </Dialog>

      {/* Info Drawer */}
      <EntryInfoDrawer
        open={infoDrawerOpen}
        onClose={() => setInfoDrawerOpen(false)}
        parentEntryIds={entry?.parentEntries}
        workspaceId={workspaceId}
      />

      {/* Comments Drawer */}
      {commentsEnabled && (
        <CommentsDrawer
          open={commentsDrawerOpen}
          onClose={() => setCommentsDrawerOpen(false)}
          workspaceId={workspaceId}
          entryId={id}
          contentTypeId={entry?.contentTypeId}
          fieldAnchor={commentsFieldAnchor}
        />
      )}
      <ScrollToTopFab triggerRef={saveButtonRef} />

      {/* AI generate-entry modal (create mode) */}
      <AiGenerateEntryModal
        isOpen={aiGenerateOpen}
        onClose={() => setAiGenerateOpen(false)}
        workspaceId={workspaceId}
        contentTypeId={getContentTypeId()}
        fieldDefs={contentType?.contentType?.fields || data || []}
        locale={spaceLocales?.[0] || 'en'}
        onApply={applyAiGeneratedFields}
        onPickReference={openModal}
        onCreateReference={onCreateReference}
      />

    </div>
  );
};

export default CreateEntry;
